import Button from "@material-ui/core/Button";
import Checkbox from "@material-ui/core/Checkbox";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import Divider from "@material-ui/core/Divider";
import Drawer from "@material-ui/core/Drawer";
import Grid from "@material-ui/core/Grid";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemIcon from "@material-ui/core/ListItemIcon";
import ListItemText from "@material-ui/core/ListItemText";
import Paper from "@material-ui/core/Paper";
import Popover from "@material-ui/core/Popover";
import withStyles from "@material-ui/core/styles/withStyles";
import Tab from "@material-ui/core/Tab";
import Tabs from "@material-ui/core/Tabs";
import Tooltip from "@material-ui/core/Tooltip";
import Add from "@material-ui/icons/Add";
import rightArrow from "Assets/newicons/arrow/chevron/right/outline/chevron-right-outline-16px.svg";
import brightness from "Assets/Svg/brightness.svg";
import { reactVersion } from "Actions/commonAction";
import {
  removeSaveProgress,
  setSaveProgress,
} from "Actions/SaveProgressAction";
import deleteIcon from "Assets/newicons/action/delete-bin/outline/delete-bin-outline-16px.svg";
import calendarIcon from "Assets/newicons/app/sumcal/outline/sumcal-outline-16px.svg";
import broadcastIcon from "Assets/newicons/notify/broadcast/outline/broadcast-outline-16px.svg";
import attachmentIcon from "Assets/Svg/attachment.svg";
import cancelIcon from "Assets/Svg/cancel.svg";
import documentIcon from "Assets/Svg/document-icon.svg";
import checkingBoxes from "Assets/Svg/no-ideas.svg";
import thumbsupicon from "Assets/Svg/thumbs-up.png";
import { DatePickerComponent } from "Component/Custom";
import DynamicForm from "Component/DynamicForm";
import { checkboxinputconverter } from "Component/DynamicForm/Fields/CheckBox";
import { selectinputconverter } from "Component/DynamicForm/Fields/Select";
import { textinputconverter } from "Component/DynamicForm/Fields/Text";
import IconLabel from "Component/Labels/IconLabel";
import Thumbnail from "Component/Thumbnail/ThumbnailSmall";
import Configs from "Constants/Configs";
import { getUrlExtension } from "Handlers/getters";
import moment from "moment";
import { withSnackbar } from "notistack";
import PropTypes from "prop-types";
import React from "react";
import { Calendar, momentLocalizer } from "react-big-calendar";
import Dropzone from "react-dropzone";
import { Helmet } from "react-helmet";
// import Lottie from "react-lottie-player";
import { LottiePlayer as Lottie } from "Library/lottie-player";
import ReactQuill from "react-quill";
import incometaxdepartment from "Assets/Svg/income-tax-department.svg";
import esic from "Assets/Svg/esic.svg";

import epfo from "Assets/Svg/epfo.svg";

import { connect } from "react-redux";
import { Link } from "react-router-dom";
import Select from "react-select";
import { bindActionCreators } from "redux";
import { instance, instanceMultipart } from "../../../Actions/AxiosInstance";
import attendanceIcon from "../../../Assets/Icons/Attendance/attendance-16px.svg";
import bulb from "../../../Assets/Icons/bulb-16px.svg";
import Celebrate from "../../../Assets/Icons/Celebrate/celebrate-16px.svg";
import clock from "../../../Assets/Icons/Clock-time/clock-time-16px.svg";
import department from "../../../Assets/Icons/Department/department-16px.svg";
import designation from "../../../Assets/Icons/Designation/designation-16px.svg";
import holidays from "../../../Assets/Icons/Holiday/holiday-16px.svg";
import lateMark from "../../../Assets/Icons/Hourglass/hourglass-16px.svg";
import newTab from "../../../Assets/Icons/new-tab-w.svg";
import phone from "../../../Assets/Icons/Phone/phone-16px.svg";
import requests from "../../../Assets/Icons/Request-center/request-center-16px.svg";
import defaultEmp from "../../../Assets/Images/defaultEmp.svg";
import filterIcon from "../../../Assets/newicons/action/filter/outline/filter-outline-b-16px.svg";
import emailIcon from "../../../Assets/newicons/user-interface/mail/outline/mail-outline-16px.svg";
import DrawerHeader from "../../../Component/Headers/drawerHeader";
import LabelIcon from "../../../Component/Labels/LabelIcon";
import SearchSq from "../../../Component/Material-ui/SearchSq";
import TextArea from "../../../Component/Material-ui/TextArea";
import ProfilePicture from "../../../Component/Thumbnail/ProfilePicture";
import headersList from "../../../Constants/headersList";
import {
  getEJ2CalenderDateFormat,
  getFormattedDate,
  getFormattedDaymonth,
  getFormattedImageLink,
} from "../../../Utils";
import AdminSpace from "./AdminSpace";
import "./index.scss";
import WarningSign from "../../../Assets/Images/warning-sign.svg";
import { height } from "@mui/system";
import RightArrow from "../../../Assets/Images/rghtarrw.svg";
import { track, identify, Identify } from "@amplitude/analytics-browser";
import PayrollComplianceCallOut from "Component/Payrollwidget/PayrollComplianceCallOut";

const modules = {
  toolbar: [
    [{ header: [1, 2, 3, 4, 5, 6, false] }],
    ["bold", "italic", "underline", "strike", "blockquote"],
    [
      { list: "ordered" },
      { list: "bullet" },
      { indent: "-1" },
      { indent: "+1" },
    ],
    ["link"], // image
    ["clean"],
  ],
};

const formats = [
  "header",
  "bold",
  "italic",
  "underline",
  "strike",
  "blockquote",
  "list",
  "bullet",
  "indent",
  "link",
];

const localizer = momentLocalizer(moment);

const lottieObj = {
  loop: true,
  autoplay: true,
  animationData: require("../../../Assets/lottie-jsons/signup_done.json"),
  rendererSettings: {
    preserveAspectRatio: "xMidYMid slice",
  },
};

const styles = (theme) => ({
  root: {
    flexGrow: 1,
    zIndex: 1,
    overflow: "hidden",
    position: "relative",
    display: "flex",
  },
  padding40: {
    padding: 0,
  },
  drawerPaper: {
    width: "30%",
  },
});

const CustomEventContainer =
  ({
    openeventdetails,
    closeeventdetails,
    closedetails,
    view,
    eventdetails,
    eventdetails_anchorEl,
    selectedeventtype,
    defaultEmp,
    loadMonthEventItems,
    selectedDate,
    openDrawer,
    DrawerOpen,
    closeDrawer,
    weekviewdata,
    getData,
    downloadhtml,
    groupeddata,
    data1,
    data2,
    paysliploading,
    defaultDate,
    showeventdetails,
  }) =>
  (props) =>
    (
      <CustomEvent
        events={props}
        openeventdetails={openeventdetails}
        closeeventdetails={closeeventdetails}
        closedetails={closedetails}
        eventdetails={eventdetails}
        eventdetails_anchorEl={eventdetails_anchorEl}
        selectedeventtype={selectedeventtype}
        view={view}
        selectedDate={selectedDate}
        data1={data1}
        data2={data2}
        defaultDate={defaultDate}
        showeventdetails={showeventdetails}
      />
    );

const GetNumberOfEmp = (count) => {
  if (count >= 4) {
    return count - 4;
  }
  return 0;
};

const CustomEvent = (props) => (
  <div>
    {props.view == "month" && (
      <div
        className="month-view-item position-rel"
        onClick={() => props.showeventdetails(props.events.event.start)}
      >
        <div
          className="cal-event-cell"
          style={{
            width: 44,
            marginTop: -2,
            height: 42,
            textAlign: "center",
            marginLeft: -4,
            paddingTop: 10,
          }}
        >
          {props.events.event.onLeave &&
            props.events.event.onLeave.count > 0 && (
              <span
                className="event-dot"
                style={{ backgroundColor: "#2D75FF" }}
              ></span>
            )}

          {props.events.event.onHoliday &&
            props.events.event.onHoliday.count > 0 && (
              <span
                className="event-dot"
                style={{ backgroundColor: "#FF45E4" }}
              ></span>
            )}

          {props.events.event.event && props.events.event.event.count > 0 && (
            <span
              className="event-dot"
              style={{ backgroundColor: "#FF653B" }}
            ></span>
          )}

          {props.events.event.shiftchange &&
            props.events.event.shiftchange.length > 0 && (
              <span
                className="event-dot"
                style={{ backgroundColor: "#FAC710" }}
              ></span>
            )}

          {props.events.event.checklist &&
            props.events.event.checklist.length > 0 && (
              <span
                className="event-dot"
                style={{ backgroundColor: "#12CDD4" }}
              ></span>
            )}

          {props.events.event.reviewform &&
            props.events.event.reviewform.open.length > 0 && (
              <span
                className="event-dot"
                style={{ backgroundColor: "#8FD14F" }}
              ></span>
            )}

          {props.events.event.reviewform &&
            props.events.event.reviewform.close.length > 0 && (
              <span
                className="event-dot"
                style={{ backgroundColor: "#8FD14F" }}
              ></span>
            )}

          {props.events.event.paryoll.length > 0 && (
            <span
              className="event-dot"
              style={{ backgroundColor: "#414BB2" }}
            ></span>
          )}
        </div>

        {((props.events.event.checklist &&
          props.events.event.checklist.length > 0) ||
          (props.events.event.event &&
            props.events.event.event.count &&
            props.events.event.event.count > 0) ||
          props.events.event.onHoliday.count > 0 ||
          props.events.event.onLeave.count > 0 ||
          props.events.event.paryoll.length > 0 ||
          props.events.event.reviewform.count > 0 ||
          props.events.event.shiftchange.length > 0) && (
          <Paper className="cal-month-view-item-list rounded-rectangle-div">
            <ul
              className="padding-left-0 super-thin-scroll"
              style={{
                listStyleType: "none",
                width: 151,
                marginTop: 0,
                height: 108,
                overflowY: "auto",
              }}
            >
              {props.events.event.onLeave &&
                props.events.event.onLeave.count > 0 && (
                  <li className="cal-widget-list-item">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#2D75FF",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Leaves
                      </span>
                    </div>
                    <span className="rounded-span">
                      {props.events.event.onLeave.count}
                    </span>
                  </li>
                )}

              {props.events.event.onHoliday &&
                props.events.event.onHoliday.count > 0 && (
                  <li className="cal-widget-list-item">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#FF45E4",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Holidays
                      </span>
                    </div>

                    <span className="rounded-span">
                      {props.events.event.onHoliday &&
                        props.events.event.onHoliday.count}
                    </span>
                  </li>
                )}

              {props.events.event.event &&
                props.events.event.event.count > 0 && (
                  <li className="cal-widget-list-item position-rel">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#FF653B",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Events
                      </span>
                    </div>

                    {props.events.event.event &&
                      props.events.event.event.count &&
                      props.events.event.event.count != 0 && (
                        <span className="rounded-span">
                          {props.events.event.event.count}
                        </span>
                      )}
                  </li>
                )}

              {props.events.event.shiftchange &&
                props.events.event.shiftchange.length > 0 && (
                  <li className="cal-widget-list-item">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#FAC710",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Shift change
                      </span>
                    </div>
                  </li>
                )}

              {props.events.event.checklist &&
                props.events.event.checklist.length > 0 && (
                  <li className="cal-widget-list-item">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#12CDD4",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Checklist item
                      </span>
                    </div>

                    <span className="rounded-span">
                      {props.events.event.checklist.length}
                    </span>
                  </li>
                )}

              {props.events.event.reviewform &&
                props.events.event.reviewform.open.length > 0 && (
                  <li className="cal-widget-list-item">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#8FD14F",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Review start
                      </span>
                    </div>

                    <span className="rounded-span">
                      {props.events.event.reviewform.open.length}
                    </span>
                  </li>
                )}

              {props.events.event.reviewform &&
                props.events.event.reviewform.close.length > 0 && (
                  <li className="cal-widget-list-item">
                    <div
                      className="display-flex"
                      style={{ alignItems: "center" }}
                    >
                      <span
                        className="event-dot"
                        style={{
                          backgroundColor: "#8FD14F",
                          width: 8,
                          height: 8,
                        }}
                      ></span>
                      <span
                        className="extra-small-dark margin-left-8"
                        style={{ color: "#0D0D0D", fontWeight: 400 }}
                      >
                        Review end
                      </span>
                    </div>

                    <span className="rounded-span">
                      {props.events.event.reviewform.close.length}
                    </span>
                  </li>
                )}

              {props.events.event.paryoll.length > 0 && (
                <li className="cal-widget-list-item">
                  <div
                    className="display-flex"
                    style={{ alignItems: "center" }}
                  >
                    <span
                      className="event-dot"
                      style={{
                        backgroundColor: "#414BB2",
                        width: 8,
                        height: 8,
                      }}
                    ></span>
                    <span
                      className="extra-small-dark margin-left-8"
                      style={{ color: "#0D0D0D", fontWeight: 400 }}
                    >
                      Payslip generated
                    </span>
                  </div>
                </li>
              )}
            </ul>
            {/* <p
              className="extra-small-blue t-bold cursor-pointer"
              onClick={() => props.showeventdetails(props.events.event.start)}
            >
              View details
            </p> */}
          </Paper>
        )}
      </div>
    )}
  </div>
);

const Leavetype = ({ leave }) => (
  <Grid item xs={12} md={1} sm={12}>
    <Tooltip title={leave.leavename}>
      <p className="t-12 margin-top-2">
        {leave.leavetypeid == 1
          ? "🏆"
          : leave.leavetypeid == 2
          ? "🤒"
          : leave.leavetypeid == 3
          ? "⏱"
          : leave.leavetypeid == 4
          ? "💸"
          : leave.leavetypeid == 5
          ? "️️✏️"
          : leave.leavetypeid == 6
          ? "🤰"
          : leave.leavetypeid == 7
          ? "👶"
          : leave.leavetypeid == 8
          ? "🎂"
          : leave.leavetypeid == 9
          ? "🍰"
          : leave.leavetypeid == 10
          ? "💍"
          : leave.leavetypeid == 11
          ? "⛱"
          : "✈️"}
      </p>
    </Tooltip>
  </Grid>
);

const initinoticedata = {
  noticeboardid: null,
  notice: null,
  noticedetails: "",
  isackrequired: false,
  ispinned: false,
  noticedate: moment(new Date()).format("YYYY-MM-DD"),
  visibleuntil: moment(new Date()).add(1, "days"),
  // sendmailnotification: true,
  attachment: [],
  // deleteattachment: [],
  sharedfor: [
    {
      sharedfortypeid: "",
      sharedforids: "",
    },
  ],
};

let allPendingNotices;

class home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      consistentstreak: null,
      dialogOpen: false,
      reactionsDrawer: false,
      // isnotices: false,
      workingdayovertimeminute: null,
      nonworkingdayovertimeminute: null,
      totalovertimeminute: null,
      pendingrequestcount: null,
      latemarkcount: null,
      isonleave: true,
      isnotclockin: true,
      isclockout: true,
      isclockin: true,
      isfilterapply: false,
      isdrawersearch: false,
      ismanager: null,
      upcomingLeaves: [],
      upcomingTodaysLeaves: [],
      upcomingOthersLeaves: [],
      upcomingHolidays: [],
      upcomingEvents: [],
      openForm: false,
      success: false,
      feedback: "",
      isdraweropen: false,
      isupdate: false,
      value: 0,
      issearch: false,
      empfilterid: 1,
      floordeskdetails: [],
      onleave: [],
      clockin: [],
      clockout: [],
      loading: false,
      calloading: false,
      withoutclockin: [],
      onleave1: [],
      clockin1: [],
      clockout1: [],
      withoutclockin1: [],
      backupclockin: [],
      backupclockout: [],
      backupwithoutclockin: [],
      backuponleave: [],
      profiledetail: false,
      profiledetail1: false,
      profiledetail2: false,
      profiledetail3: false,
      sortmenu: false,
      sort_anchorEl: null,
      profiledetaildata: [],
      tabvalue: 0,

      fromdate: new Date(),
      todate: new Date(),
      cardfilterids: [1, 2, 3, 4, 5, 6, 7],
      cardsubfilterids: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],

      defaultEmp,

      responsetypemenu: false,
      responsetype_anchorEl: null,
      eventdetails: false,
      eventdetails_anchorEl: null,

      selectedDate: new Date(),
      defaultDate: new Date(),

      maxDate: new Date(),
      minDate: new Date(),

      monthviewdata: [],

      view: "month",

      monthName: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],

      holidayyear: new Date().getFullYear(),
      newattachments: [],

      isacknowledge: false,
      selectedNotice: null,
      alldepartmentslist: [],
      allofficelocationlist: [],
      selectedDepartment: null,
      selectedOfficelocation: null,
      selectedLocationIds: null,
      selectedDepartementIds: null,
      offset: 0,
      maxnoticedate: new Date(new Date().setDate(new Date().getDate() + 30)),
      allNotices: [],
      allMandatoryNotices: [],
      allreactions: [],
      acknowledgmenttypes: [
        { displayvalue: 1, displayname: "Yes" },
        { displayvalue: 2, displayname: "No" },
      ],
      isackrequired: 2,
      sharedtypes: [
        { displayvalue: 1, displayname: "Everyone" },
        { displayvalue: 2, displayname: "Department" },
      ],
      sharedid: 1,

      loadingnotices: true,
      isoldnotices: true,
      noticeData: {
        noticeboardid: null,
        notice: null,
        noticedetails: "",
        isackrequired: false,
        ispinned: false,
        noticedate: moment(new Date()).format("YYYY-MM-DD"),
        visibleuntil: moment(new Date()).add(1, "days"),
        // sendmailnotification: true,
        attachment: [],
        // deleteattachment: [],
        sharedfor: [
          {
            sharedfortypeid: "",
            sharedforids: "",
          },
        ],
      },
    };

    this.openForm = this.openForm.bind(this);
    this.setFeedback = this.setFeedback.bind(this);
    this.sendFeedback = this.sendFeedback.bind(this);
    this.onSortMenuClick = this.onSortMenuClick.bind(this);
    this.onProfileDetails = this.onProfileDetails.bind(this);
    this.handleSearch1 = this.handleSearch1.bind(this);
    this.handleSearch = this.handleSearch.bind(this);
    this.getisemployeeManager = this.getisemployeeManager.bind(this);
    this.getMonthView = this.getMonthView.bind(this);
    this.openeventdetails = this.openeventdetails.bind(this);
    this.showeventdetails = this.showeventdetails.bind(this);
    this.closeeventdetails = this.closeeventdetails.bind(this);
    this.getFiles = this.getFiles.bind(this);
    this.getFormattedImageLink = this.getFormattedImageLink.bind(this);
    this.closedialog = this.closedialog.bind(this);
    this.createNotice = this.createNotice.bind(this);
    this.deleteNotice = this.deleteNotice.bind(this);
    this.getnoticedetails = this.getnoticedetails.bind(this);
    this.handleChange1 = this.handleChange1.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.reactToNotice = this.reactToNotice.bind(this);
    this.openReactionDrawer = this.openReactionDrawer.bind(this);
    this.getNotice1 = this.getNotice1.bind(this);
    this.reactToMandatoryNotice = this.reactToMandatoryNotice.bind(this);
    this.getCommonConfig = this.getCommonConfig.bind(this);

    const event = new Identify();

    event.set(
      "employeeId",
      this.props.AuthenticationAction.login.employeeid || 0,
    );
    event.set(
      "subscriptionId",
      this.props.AuthenticationAction.login.subscriptionid || 0,
    );

    identify(event);
  }

  async componentDidMount() {
    this.getCommonConfig();
    // this.getisemployeeManager();
    this.getEmployeeStatus();
    this.getUpcomingHoliday();
    this.getUpcomingLeaves();
    this.getUpcomingEvent();
    this.getTodaysOtherLeaves();
    this.getUpcomingOtherLeaves();
    //this.getVersion();
    this.GetJupiterMandate();

    // this.onFloormydesk();
    const d = new Date();
    const MonthName = this.state.monthName[d.getMonth()];
    this.setState({ monthName: MonthName });
    localStorage.setItem("fromhome", true);

    const noticeid = new URL(window.location.href).searchParams.get("noticeId");
    if (noticeid) {
      this.setState({ noticeid, dialogOpen: true, isnotices: false }, () =>
        this.getNotice(false),
      );
    } else {
      this.getNotice1();
    }
  }

  GetJupiterMandate() {
    const employeeid = this.props.AuthenticationAction.login.employeeid
      ? this.props.AuthenticationAction.login.employeeid
      : "";
    const URL = `/jupiteroffer/check-jupiter-account/${employeeid}`;
    instance
      .get(URL)
      .then((result) => {
        this.setState({
          ismandate:
            result.data.result.length > 0
              ? result.data.result[0].ismandate
              : false,
          isjupiteraccount:
            result.data.result.length > 0
              ? result.data.result[0].isjupiteraccount
              : false,
          ishowcompliancepromo:
            result.data.result &&
            result.data.result[0] &&
            result.data.result[0].ishowcompliancepromo,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleTabChange = (e, tabvalue) => {
    this.setState({ tabvalue });
  };

  closedialog() {
    this.setState({ dialogOpen: false });
  }

  openReactionDrawer(noticeboardid) {
    this.setState({ reactionsDrawer: true }, () =>
      this.getAllEmpReactions(noticeboardid),
    );
  }

  getCommonConfig() {
    instance
      .get("subscription/getcommonconfig")
      .then((result) => {
        this.setState(
          {
            isindepartment: result.data.result[0]
              ? result.data.result[0].isindepartment
              : true,
            isdeptshowtime: result.data.result[0]
              ? result.data.result[0].isdeptshowtime
              : true,
            isinorganization: result.data.result[0]
              ? result.data.result[0].isinorganization
              : false,
            isorgshowtime: result.data.result[0]
              ? result.data.result[0].isorgshowtime
              : true,

            iscaldepartment: result.data.result[0]
              ? result.data.result[0].iscaldepartment
              : true,
            iscalorganization: result.data.result[0]
              ? result.data.result[0].iscalorganization
              : false,
          },
          () => this.getisemployeeManager(),
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getAllEmpReactions(noticeboardid) {
    instance
      .get(`/trackdashboard/getnoticeallreaction/${noticeboardid}`)
      .then((result) => {
        this.setState({
          allreactions: result.data.result,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  ConvertDate = (str) => {
    const date = new Date(str);
    const mnth = `0${date.getMonth() + 1}`.slice(-2);
    const day = `0${date.getDate()}`.slice(-2);
    return [date.getFullYear(), mnth, day].join("-");
  };

  handleDateChange(key, args) {
    const date = this.ConvertDate(args.value);
    this.setState({ noticeData: { ...this.state.noticeData, [key]: date } });
  }

  getFormattedImageLink(link) {
    const ext1 = getUrlExtension(link);
    // const ext1 = ext || getUrlExtension(docUrl);
    switch (ext1) {
      case "jpg":
      case "jpeg":
      case "png":
        return `${Configs.STORE_URL}${link}`;
      case "pdf":
      case "ppt":
      case "pptx":
      case "doc":
      case "docx":
      case "txt":
      case "text":
      case "rtf":
      case "odt":
        return documentIcon;
      default:
        return null;
    }
  }

  getFiles(files) {
    const { AuthenticationAction } = this.props;
    const id = this.state.colleagueid || this.state.employeeid;
    const file = files[0];
    const formData = new FormData();
    formData.append("file", file);
    instanceMultipart
      .post(
        `/drive/uploaddocument/${this.props.SubscriptionData.subscriptionid}/${this.props.SubscriptionData.employeeid}`,
        formData,
      )
      .then((resp) => {
        const { newattachments } = this.state;
        newattachments.push({
          // ...resp.data.result[0],
          // noticeboardfileid: null,
          filename: files[0].name,
          filepath: resp.data.result[0].imagepath,
        });
        this.setState({ newattachments });
      });
  }

  getMonthView() {
    const data = {
      fromdate: moment(this.state.selectedDate)
        .startOf("month")
        .format("YYYY-MM-DD"),
      todate: moment(this.state.selectedDate)
        .endOf("month")
        .format("YYYY-MM-DD"),
      empfilterid: 2,
      cardfilterids: this.state.cardfilterids,
      cardsubfilterids: this.state.cardsubfilterids,
      limit: this.state.limit,
      offset: this.state.offset,
    };

    this.setState({ calloading: true }, () => {
      instance
        .post(`trackdashboard/getmonthview`, data)
        .then((result) => {
          if (result.data.result.length > 0) {
            this.setState(
              {
                monthviewdata: result.data.result
                  ? result.data.result.map((x) => {
                      const holidaydate = x.date.split("-");
                      const year = holidaydate[0];
                      const month = holidaydate[1];
                      const day = holidaydate[2];
                      return {
                        ...x,
                        end: new Date(year, month - 1, day),
                        start: new Date(year, month - 1, day),
                      };
                    })
                  : [],
                responsetypemenu: false,
                responsetype_anchorEl: null,
                // view: this.state.calendarview,
                calloading: false,
              },
              // () => this.getWeekView(),
            );
          } else {
            this.setState({ calloading: false });
          }
        })
        .catch((error) => {
          this.setState({ calloading: false });
          this.props.enqueueSnackbar(
            error.response ? error.response.data.error.message : error.message,
            { variant: "error" },
          );
        });
    });
  }

  onFloormydesk() {
    // const { match } = this.props;
    // await this.getisemployeeManager();

    const data = {
      empfilterid: this.state.empfilterid,
      // fromdate: "2020-12-30",
      // todate: "2021-01-05",
      isshowtime:
        this.state.empfilterid == 2 &&
        this.props.AuthenticationAction &&
        this.props.AuthenticationAction.login &&
        this.props.AuthenticationAction.login.masterprofileid &&
        this.props.AuthenticationAction.login.masterprofileid != 9
          ? this.state.isdeptshowtime
          : this.state.empfilterid == 3 &&
            this.props.AuthenticationAction &&
            this.props.AuthenticationAction.login &&
            this.props.AuthenticationAction.login.masterprofileid &&
            this.props.AuthenticationAction.login.masterprofileid != 9
          ? this.state.isorgshowtime
          : true,
    };
    instance
      .post("trackdashboard/myfloordesk", data)
      .then((result) => {
        const onleave = [];
        result.data.result[0].onoptionalholiday &&
          result.data.result[0].onoptionalholiday.map((x) => onleave.push(x));
        const clockin = result.data.result[0].withclockin;
        const clockout = result.data.result[0].withclockout;
        const withoutclockin = result.data.result[0].withoutclockin;

        // const newwithout = withoutclockin.map((option) => ({
        //   ...option,
        //   officeaddressid: 561,
        // }));
        this.setState({
          floordeskdetails: result.data.result[0],
          onleave: [...onleave, ...result.data.result[0].onleave],
          clockin,
          backupclockin: clockin,
          backupclockout: clockout,
          backupwithoutclockin: withoutclockin,
          backuponleave: [...onleave, ...result.data.result[0].onleave],
          clockin1: clockin,
          clockout1: clockout,
          withoutclockin1: [...withoutclockin],

          onleave1: [...onleave, ...result.data.result[0].onleave],
          clockout,
          // ismanager: result.data.result[0].ismanager,
          withoutclockin,
          loading: false,
        });
      })
      .catch((error) => {
        this.setState({
          loading: false,
        });
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  // async getVersion() {
  //   let { isupdate } = this.state;
  //   const version = await instance.get(`superuser/getallappversion/1/1`);
  //   if (
  //     version.data.result[0] &&
  //     (version.data.result[0].version != this.props.version ||
  //       !this.props.version)
  //   ) {
  //     isupdate = true;
  //   }

  //   this.setState({ version: version.data.result[0], isupdate });
  // }

  openeventdetails(e, date) {
    this.setState({
      // OptionalDrawerOpen: true,
      eventdetails: true,
      selectedDate: date,
    });
  }

  showeventdetails(date) {
    const eventdate = moment(date).format("YYYY-MM-DD");
    // this.props.history.push(`/calendar/${eventdate}`);
    this.props.history.push(`/calendar`);
    localStorage.setItem("fromhome", true);
    localStorage.setItem("setdefaultdate", date);
    // const employeeLink = `${window.location.origin}/calendar/${eventdate}`;
    // window.open(employeeLink, "_blank");

    this.setState({
      // selectedDate: date,
    });
  }

  closeeventdetails(e) {
    console.log("avsbcndc");
    this.setState({
      // OptionalDrawerOpen: true,
      eventdetails: false,
      selectedDate: null,
    });
  }

  onProfileDetails(employeeid, e, index, key) {
    console.log("hii");
    if (key == "withoutclockin") {
      this.setState({
        profiledetail: !this.state.profiledetail,
        profiledetail_anchorEl: e.currentTarget,
      });
    }
    if (key == "clockout") {
      this.setState({
        profiledetail1: !this.state.profiledetail,
        profiledetail1_anchorEl: e.currentTarget,
      });
    }
    if (key == "clockin") {
      this.setState({
        profiledetail2: !this.state.profiledetail,
        profiledetail2_anchorEl: e.currentTarget,
      });
    }
    if (key == "onleave") {
      this.setState({
        profiledetail3: !this.state.profiledetail,
        profiledetail3_anchorEl: e.currentTarget,
      });
    }
    instance
      .get(`/subscription/empcardinfo/${employeeid}`)
      .then((result) => {
        this.setState({
          // profiledetail: true,
          // profiledetail: !this.state.profiledetail,
          // event: e.currentTaget,

          profiledetaildata: result.data.result[0],
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getisemployeeManager() {
    const employeeid =
      this.props.AuthenticationAction &&
      this.props.AuthenticationAction.login &&
      this.props.AuthenticationAction.login.employeeid;
    instance
      .get(`/trackdashboard/isemployeemanager/${employeeid}`)
      .then((result) => {
        this.setState(
          {
            ismanager: result.data.result[0].ismanager,
            empfilterid:
              result.data.result[0].ismanager == false
                ? 2
                : this.state.empfilterid,
          },
          () => {
            (this.state.isindepartment ||
              this.state.isdeptshowtime ||
              this.state.isinorganization ||
              this.state.isorgshowtime ||
              this.state.iscaldepartment ||
              this.state.iscalorganization ||
              this.state.ismanager ||
              (this.props.AuthenticationAction &&
                this.props.AuthenticationAction.login &&
                this.props.AuthenticationAction.login.masterprofileid &&
                this.props.AuthenticationAction.login.masterprofileid == 9)) &&
              this.onFloormydesk();
            this.getMonthView();
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getEmployeeStatus() {
    instance
      .post("trackdashboard/employeestat")
      .then((result) => {
        this.setState({
          consistentstreak: result.data.result[0].consistentstreak,
          latemarkcount: result.data.result[0].latemarkcount,
          workingdayovertimeminute:
            result.data.result[0].workingdayovertimeminute,
          nonworkingdayovertimeminute:
            result.data.result[0].nonworkingdayovertimeminute,
          totalovertimeminute:
            parseInt(result.data.result[0].workingdayovertimeminute) +
            parseInt(result.data.result[0].nonworkingdayovertimeminute),
          pendingrequestcount: result.data.result[0].pendingrequestcount,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  createNotice() {
    let { noticeData, isackrequired, sharedid, selectedDepartementIds } =
      this.state;
    noticeData.attachment = this.state.newattachments;

    noticeData.isackrequired = isackrequired == 1 ? true : false;
    noticeData.sharedfor[0].sharedfortypeid = sharedid == 1 ? 0 : 3;
    noticeData.sharedfor[0].sharedforids =
      sharedid == 1 ? "0" : selectedDepartementIds;
    const { issaveinprogress } = this.props.SaveInProgressReducer;
    this.props.enqueueSnackbar(
      "Are you sure you want to publish this notice?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              if (!issaveinprogress) {
                this.props.setSaveProgress(true);
                instance
                  .post("trackdashboard/createnotice", noticeData)
                  .then((result) => {
                    this.props.removeSaveProgress();
                    this.props.enqueueSnackbar("Published successfully", {
                      variant: "success",
                    });
                    const noticeboardid = result.data.result[0].noticeboardid;
                    noticeData = { ...initinoticedata };
                    this.setState(
                      {
                        noticeData,
                        newattachments: [],
                        isnewnotice: false,
                        selectedDepartment: null,
                      },
                      () => {
                        // noticeData.isackrequired &&
                        this.reactToNotice(noticeboardid, 99);
                        this.getNotice(false);
                      },
                    );
                  })
                  .catch((error) => {
                    this.props.removeSaveProgress();
                    this.setState({
                      noticeData: {
                        noticeboardid: null,
                        notice: null,
                        noticedetails: "",
                        isackrequired: false,
                        ispinned: false,
                        noticedate: moment(new Date()).format("YYYY-MM-DD"),
                        visibleuntil: moment(new Date()).add(1, "days"),
                        // sendmailnotification: true,
                        attachment: [
                          {
                            noticeboardfileid: "",
                            filename: "",
                            filepath: "",
                          },
                        ],
                        // deleteattachment: [],
                        sharedfor: [
                          {
                            sharedfortypeid: "",
                            sharedforids: "",
                          },
                        ],
                      },
                      newattachments: [],
                    });
                    const CommonError = error.response
                      ? error.response.data.error.message
                      : error.message;
                    this.props.enqueueSnackbar(CommonError, {
                      variant: "error",
                    });
                  });
              }
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  GetEmployeesDepartmentList() {
    const data = {
      featurekey: "directory",
    };
    instance
      .post(`subscription/alldepartment`, data)
      .then((result) => {
        this.setState({ alldepartmentslist: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  GetAllLocationList() {
    const data = {
      featurekey: "directory",
      subscriptionid: this.props.SubscriptionData.subscriptionid,
    };
    instance
      .post(`subscription/allcompanylocation`, data)
      .then((result) => {
        this.setState({ allofficelocationlist: result.data.result });
      })
      .catch((error) => {
        this.props.enqueueSnackbar(
          error.response ? error.response.data.error.message : error.message,
          { variant: "error" },
        );
      });
  }

  deleteNotice() {
    const data = {
      noticeboardid: this.state.selectedNotice.noticeboardid,
    };

    this.props.enqueueSnackbar(
      "Deleted notices are permanently removed from your and all employee's noticeboard. Do you still want to delete this notice?",
      {
        variant: "warning",
        action: [
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={() => {
              this.props.closeSnackbar();
              instance
                .delete(
                  `trackdashboard/deletenotice/${this.state.selectedNotice.noticeboardid}`,
                )
                .then(() => {
                  this.props.enqueueSnackbar("Deleted successfully", {
                    variant: "success",
                  });

                  this.setState(
                    {
                      selectedNotice: null,
                      // data: [],
                      // offset: 0,
                      // backupList: [],
                      // totalcount: 1,
                      dialogOpen: false,
                    },
                    () => {
                      this.getNotice(false);
                    },
                  );
                })
                .catch((error) => {
                  this.setState({
                    dialogOpen: false,
                  });
                  this.props.closeSnackbar();
                });
            }}
          >
            Yes
          </Button>,
          <Button
            key="key"
            color="inherit"
            size="small"
            onClick={this.props.closeSnackbar()}
          >
            No
          </Button>,
        ],
      },
    );
  }

  getNotice(isarchive = false) {
    const { allNotices } = this.state;
    this.setState({ loadingnotices: true }, () => {
      instance
        .get(
          `trackdashboard/getnotice/${isarchive}/100/${this.state.offset}/0/${
            this.state.noticeid ? this.state.noticeid : ""
          }`,
        )
        .then((result) => {
          this.setState({
            allNotices: result.data.result,
            selectedNotice: this.state.noticeid ? result.data.result[0] : null,
            loadingnotices: false,
          });
        })
        .catch((error) => {
          this.setState({ loadingnotices: false });
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    });
  }

  getNotice1() {
    const { allMandatoryNotices } = this.state;

    instance
      .get(`trackdashboard/getnotice/false/100/${this.state.offset}/1`)
      .then((result) => {
        const allmnotices = result.data.result;

        this.setState(
          {
            allMandatoryNotices: allmnotices,
            isnotices: allmnotices.length > 0 ? true : false,
            mandatorycount: allmnotices.length,
          },
          () => {
            result.data.result.length == 0 && this.getNotice(false);
          },
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  reactToNotice(noticeboardid, reactionid) {
    const data = {
      noticeboardid,
      reactionid,
    };
    instance
      .post("trackdashboard/noticereaction", data)
      .then((result) => {
        this.setState(
          {
            allNotices: result.data.result,
            dialogOpen: false,
          },
          () => this.getNotice(),
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  reactToMandatoryNotice(noticeboardid) {
    const data = {
      noticeboardid,
      reactionid: 99,
    };
    instance
      .post("trackdashboard/noticereaction", data)
      .then((result) => {
        this.setState({ mandatorycount: this.state.mandatorycount }, () =>
          this.getNotice1(),
        );
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getnoticedetails(notice) {
    this.setState({
      dialogOpen: true,
      selectedNotice: notice,
    });
  }

  getUpcomingEvent() {
    instance
      .post("hrisdashboard/upcomingevent")
      .then((result) => {
        const upcomingEvents = [
          ...(result.data.result[0].birthday &&
            result.data.result[0].birthday.map((hol) => ({
              ...hol,
              birthday: true,
              work: false,
              mrg: false,
            }))),
          ...(result.data.result[0].workanniversary &&
            result.data.result[0].workanniversary.map((hol) => ({
              ...hol,
              birthday: false,
              work: true,
              mrg: false,
            }))),
          ...(result.data.result[0].marriageanniversary &&
            result.data.result[0].marriageanniversary.map((hol) => ({
              ...hol,
              birthday: false,
              work: false,
              mrg: true,
            }))),
        ];

        this.setState({
          upcomingEvents,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getUpcomingHoliday() {
    instance
      .post("trackdashboard/upcomingholiday")
      .then((result) => {
        const upcomingHolidays = [
          ...(result.data.result[0].mandatory &&
            result.data.result[0].mandatory.map((hol) => ({
              ...hol,
              ismandatory: true,
            }))),
          ...(result.data.result[0].optional &&
            result.data.result[0].optional.map((hol) => ({
              ...hol,
              ismandatory: false,
            }))),
        ];

        this.setState({
          upcomingHolidays,
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getUpcomingLeaves() {
    instance
      .post("trackdashboard/upcomingleave")
      .then((result) => {
        this.setState({
          upcomingLeaves: result.data.result || [],
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getTodaysOtherLeaves() {
    instance
      .post("trackdashboard/departmentwiseonleaveemployee", { istoday: true })
      .then((result) => {
        this.setState({
          upcomingTodaysLeaves: result.data.result || [],
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  getUpcomingOtherLeaves() {
    instance
      .post("trackdashboard/departmentwiseonleaveemployee")
      .then((result) => {
        this.setState({
          upcomingOthersLeaves: result.data.result || [],
        });
      })
      .catch((error) => {
        const CommonError = error.response
          ? error.response.data.error.message
          : error.message;
        this.props.enqueueSnackbar(CommonError, { variant: "error" });
      });
  }

  handleChange = (event, value) => {
    this.setState({ value });
  };

  handleChange1(key, value) {
    // this.setState({ [key]: value });
    if (key == "isackrequired" || key == "sharedid") {
      this.setState({ [key]: value });
    } else if (key == "selectedDepartementIds") {
      this.setState({
        selectedDepartment: value,
        [key]: value && value.map((x) => x.displayvalue).join(","),
      });
    } else if (key == "selectedLocationIds") {
      const withoutclockin1 = value
        ? this.state.withoutclockin &&
          this.state.withoutclockin.filter(
            (op) =>
              value &&
              value.some((hol) => hol.displayvalue == op.officeaddressid) &&
              true,
          )
        : this.state.withoutclockin;
      const clockout1 = value
        ? this.state.clockout &&
          this.state.clockout.filter(
            (op) =>
              value &&
              value.some((hol) => hol.displayvalue == op.officeaddressid) &&
              true,
          )
        : this.state.clockout;
      const clockin1 = value
        ? this.state.clockin &&
          this.state.clockin.filter(
            (op) =>
              value &&
              value.some((hol) => hol.displayvalue == op.officeaddressid) &&
              true,
          )
        : this.state.clockin;
      const onleave1 = value
        ? this.state.onleave &&
          this.state.onleave.filter(
            (op) =>
              value &&
              value.some((hol) => hol.displayvalue == op.officeaddressid) &&
              true,
          )
        : this.state.onleave;
      this.setState({
        selectedOfficelocation: value,
        [key]: value && value.map((x) => x.displayvalue),

        withoutclockin1,

        clockout1,
        clockin1,
        onleave1,
        backupclockin: clockin1,
        backupclockout: clockout1,
        backupwithoutclockin: withoutclockin1,
        backuponleave: onleave1,
      });
    } else {
      this.setState({ noticeData: { ...this.state.noticeData, [key]: value } });
    }
  }

  openForm() {
    this.setState({
      openForm: true,
      success: false,
    });
  }

  setFeedback(value) {
    this.setState({
      feedback: value,
      openForm: true,
      success: false,
    });
  }

  onSortMenuClick(event) {
    this.setState({
      // sortmenu: !this.state.sortmenu,
      sortmenu: !this.state.sortmenu,
      sort_anchorEl: event.currentTarget,
    });
  }

  getCount = (count) => {
    if (count >= 9) {
      return count - 9;
    }
    return 0;
  };

  showLoader() {
    return (
      <div className="pre-loader" style={{ height: 500 }}>
        Loading...
      </div>
    );
  }

  sendFeedback() {
    if (this.state.feedback != "" && this.state.feedback != null) {
      const data = {
        feedbackrelatedtypeid: 3,
        feedback: this.state.feedback,
        feedbacktypeid: 99,
        via: "Dashboard widget request",
      };
      instance
        .post("superuser/feedback", data)
        .then(() => {
          this.props.enqueueSnackbar("Save successfully", {
            variant: "success",
          });
          this.setState({
            openForm: true,
            success: true,
          });
        })
        .catch((error) => {
          const CommonError = error.response
            ? error.response.data.error.message
            : error.message;
          this.props.enqueueSnackbar(CommonError, { variant: "error" });
        });
    } else {
      this.props.enqueueSnackbar("Please fill something", { variant: "error" });
    }
  }

  handleSearch(e) {
    const {
      tabvalue,
      clockin,
      clockout,
      withoutclockin,
      onleave,
      backupclockin,
      backupclockout,
      backupwithoutclockin,
      backuponleave,
    } = this.state;

    const filterList1 = withoutclockin.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    const filterList2 = clockout.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1 ||
        item.outtime.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    const filterList3 = clockin.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1 ||
        item.intime.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    const filterList4 = onleave.filter(
      (item) =>
        item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !== -1,
    );
    this.setState({
      searchValue: e.target.value,
      withoutclockin: e.target.value ? filterList1 : backupwithoutclockin,
      clockout: e.target.value ? filterList2 : backupclockout,
      clockin: e.target.value ? filterList3 : backupclockin,
      onleave: e.target.value ? filterList4 : backuponleave,
      issearch: e.target.value ? true : false,
      // isdata: filterList.length == 0 ? true : false,
    });
  }

  handleSearch1(e) {
    const {
      tabvalue,
      clockin1,
      clockout1,
      withoutclockin1,
      onleave1,
      backupclockin,
      backupclockout,
      backupwithoutclockin,
      backuponleave,
    } = this.state;
    if (tabvalue == 0) {
      const filterList = withoutclockin1.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchValue: e.target.value,
        withoutclockin1: e.target.value ? filterList : backupwithoutclockin,
        isdata: filterList.length == 0 ? true : false,
        isdrawersearch: e.target.value ? true : false,
      });
    } else if (tabvalue == 1) {
      const filterList = clockout1.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchValue: e.target.value,
        clockout1: e.target.value ? filterList : backupclockout,
        isdata: filterList.length == 0 ? true : false,
        isdrawersearch: e.target.value ? true : false,
      });
    } else if (tabvalue == 2) {
      const filterList = clockin1.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchValue: e.target.value,
        clockin1: e.target.value ? filterList : backupclockin,
        isdata: filterList.length == 0 ? true : false,
        isdrawersearch: e.target.value ? true : false,
      });
    } else if (tabvalue == 3) {
      const filterList = onleave1.filter(
        (item) =>
          item.fullname.toLowerCase().search(e.target.value.toLowerCase()) !==
          -1,
      );
      this.setState({
        searchValue: e.target.value,
        onleave1: e.target.value ? filterList : backuponleave,
        isdata: filterList.length == 0 ? true : false,
        isdrawersearch: e.target.value ? true : false,
      });
    }
  }

  render() {
    allPendingNotices = allPendingNotices
      ? allPendingNotices
      : this.state.allMandatoryNotices.length;

    const { onleave, clockin, clockout, withoutclockin, profiledetaildata } =
      this.state;
    // const isfilterapply =
    //   this.state.isclockin == true ||
    //   this.state.isclockout == true ||
    //   this.state.isonleave == true ||
    //   this.state.isnotclockin == true
    //     ? true
    //     : false;

    return (
      <div className="application">
        <Helmet>
          <title>{headersList.MyDesk.header}</title>
        </Helmet>
        <div className="common-menubar-header">
          <Tabs
            value={this.state.value}
            onChange={this.handleChange}
            indicatorColor="#fff"
            textColor="primary"
            scrollButtons="auto"
          >
            <Tab
              label="My space"
              className={` ${
                this.state.value == 0 ? "active-tab1" : "inactive-tab1"
              } `}
            />
            {this.props.AuthenticationAction &&
              this.props.AuthenticationAction.login &&
              this.props.AuthenticationAction.login.masterprofileid &&
              this.props.AuthenticationAction.login.masterprofileid == 9 && (
                <Tab
                  label="Admin space"
                  className={` ${
                    this.state.value == 1 ? "active-tab1" : "inactive-tab1"
                  } `}
                />
              )}
          </Tabs>
          <div className="tab-border"></div>
        </div>
        <div className="content-outer-wrapper-with-tab">
          {this.state.value == 0 && (
            <div>
              <Grid container className="display-flex">
                <Grid
                  item
                  xs={12}
                  md={8}
                  sm={12}
                  style={{ padding: "0px 12px 0px 24px" }}
                >
                  {this.props.AuthenticationAction &&
                  this.props.AuthenticationAction.login &&
                  this.props.AuthenticationAction.login.masterprofileid &&
                  this.props.AuthenticationAction.login.masterprofileid == 9 &&
                  this.state.ishowcompliancepromo ? (
                    <PayrollComplianceCallOut />
                  ) : (
                    <div>
                      {this.state.ismandate == true &&
                        this.state.isjupiteraccount == false && (
                          <div
                            style={{
                              backgroundColor: "#FEF1D9",
                              width: "692px",
                              height: "144px",
                              borderRadius: "4px",
                              padding: "16px",

                              marginBottom: "16px",
                            }}
                          >
                            <span>
                              <img
                                style={{
                                  width: "16px",
                                  height: "15px",
                                  paddingRight: "8px",
                                }}
                                src={WarningSign}
                              />
                              {/* <img src={SmsLink} /> */}
                              <span
                                style={{
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "20px",
                                  color: "#FAA500",
                                }}
                              >
                                Attention required!
                              </span>
                            </span>

                            <div
                              onClick={() => {
                                track("mydesk-jupiter-stickybar-clicked");
                              }}
                              style={{
                                fontWeight: "400",
                                fontSize: "16px",
                                lineHeight: "24px",
                                color: "#000000",
                                paddingTop: "16px",
                              }}
                            >
                              Our company disburses salary only in Jupiter
                              Account (powered by Federal Bank). Kindly create
                              one (if not already created) and add it as your
                              default bank account.
                            </div>

                            <Link
                              to={`./profile`}
                              onClick={() => {
                                track("mydesk-jupiter-cta-clicked");
                              }}
                              style={{
                                display: "flex",
                                backgroundColor: "#FAA500",
                                borderRadius: "4px",
                                borderRadius: " 4px",
                                width: "126px",
                                height: "32px",
                                marginTop: "16px",
                              }}
                            >
                              <div
                                style={{
                                  color: "#FFFFFF",
                                  fontWeight: "700",
                                  fontSize: "14px",
                                  lineHeight: "20px",
                                  padding: "6px 8px 2px 16px",
                                }}
                              >
                                See how{" "}
                              </div>
                              <img
                                style={{
                                  padding: "8px 8px",
                                  width: "16px",
                                  height: "16px",
                                }}
                                src={RightArrow}
                              />
                            </Link>
                          </div>
                        )}
                    </div>
                  )}

                  <div className="notice-board-main">
                    <div
                      className="display-flex margin-bottom-16"
                      style={{ justifyContent: "space-between" }}
                    >
                      <div
                        className="display-flex"
                        style={{ alignItems: "center" }}
                      >
                        <img src={broadcastIcon}></img>
                        <p className="small-dark-secondary t-bold margin-left-8">
                          Noticeboard
                        </p>
                      </div>
                      {this.props.AuthenticationAction &&
                        this.props.AuthenticationAction.login &&
                        this.props.AuthenticationAction.login.masterprofileid &&
                        this.props.AuthenticationAction.login.masterprofileid ==
                          9 && (
                          <Button
                            variant="contained"
                            className="btn btn-primary-sm-blue"
                            onClick={() =>
                              this.setState({ isnewnotice: true }, () =>
                                this.GetEmployeesDepartmentList(),
                              )
                            }
                          >
                            New Notice
                          </Button>
                        )}
                    </div>
                    {this.state.isnewnotice && (
                      <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                        <div>
                          {/* <div style={{ textAlign: "right" }}>
                            <img
                              src={cancelIcon1}
                              onClick={() =>
                                this.setState({ isnewnotice: false })
                              }
                              style={{ padding: 8 }}
                            ></img>
                          </div> */}
                          <div className="display-flex">
                            <div
                              className="display-flex margin-bottom-16"
                              style={{ alignItems: "center" }}
                            >
                              <div style={{ width: 24, height: 24 }}>
                                <DynamicForm
                                  fields={checkboxinputconverter({
                                    value: this.state.noticeData.ispinned,
                                    placeholder: "",
                                    label: "",
                                  })}
                                  onChange={(value) => {
                                    this.handleChange1("ispinned", value);
                                  }}
                                />
                              </div>
                              <Tooltip
                                title="Allows a notice to be on top of other non-pinned notices."
                                placement="top"
                              >
                                <p className="input-label margin-left-8">
                                  Pin this notice ℹ️
                                </p>
                              </Tooltip>
                            </div>
                            <div
                              className="display-flex margin-bottom-16 margin-left-32"
                              style={{ alignItems: "center" }}
                            >
                              <div style={{ width: 24, height: 24 }}>
                                <DynamicForm
                                  fields={checkboxinputconverter({
                                    value: this.state.noticeData.isnotifyonmail,
                                    placeholder: "",
                                    label: "",
                                  })}
                                  onChange={(value) => {
                                    this.handleChange1("isnotifyonmail", value);
                                  }}
                                />
                              </div>
                              <Tooltip
                                title="Lets you notify employees about this notice via email. Only subject of the notice is sent via email, employees will have to click a link to read details and view attachments in-app."
                                placement="top"
                              >
                                <p className="input-label margin-left-8">
                                  Notify via email ℹ️
                                </p>
                              </Tooltip>
                            </div>
                          </div>
                          <Grid container spacing={2} className="display-flex">
                            <Grid item md={8} sm={12}>
                              <div className="width100 margin-right-16">
                                <DynamicForm
                                  fields={textinputconverter({
                                    value: this.state.noticeData.notice,

                                    label: "Notice’s subject",
                                    placeholder: "Enter subject",
                                  })}
                                  onChange={(value) =>
                                    this.handleChange1("notice", value)
                                  }
                                />
                              </div>
                            </Grid>
                            <Grid item md={4} sm={12}>
                              <p className="input-label">Attachments</p>
                              <div style={{ height: 48 }}>
                                {this.state.newattachments &&
                                  this.state.newattachments.map(
                                    (img, imgindex) => (
                                      <div
                                        key="img"
                                        className="add-attachment"
                                        style={{
                                          marginRight: 16,
                                          height: 38,
                                          width: 38,
                                        }}
                                      >
                                        <img
                                          src={
                                            img &&
                                            img.filepath &&
                                            this.getFormattedImageLink(
                                              img.filepath,
                                            )
                                          }
                                          className="expense-attachment-img"
                                        />
                                        <img
                                          src={cancelIcon}
                                          style={{ zIndex: 0 }}
                                          className="remove-attachment-icon"
                                          onClick={() => {
                                            const all =
                                              this.state.newattachments;
                                            all.splice(imgindex, 1);
                                            this.setState({
                                              newattachments: all,
                                            });
                                          }}
                                        />
                                      </div>
                                    ),
                                  )}
                                <Grid
                                  style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    float: "left",
                                  }}
                                >
                                  <div
                                    className="add-attachment"
                                    style={{ height: 38, width: 38 }}
                                  >
                                    <Tooltip
                                      title="Insert attachment"
                                      placement="right"
                                    >
                                      <Dropzone
                                        onDrop={this.getFiles}
                                        multiple={false}
                                        accept="image/gif, image/jpeg, image/png, image/jpg, .pdf, .xlsx,.xls,.doc,.docx "
                                        maxSize={10485760}
                                        className="drag-drop"
                                      >
                                        <Add
                                          className="add-attachement-icon"
                                          style={{
                                            marginLeft: 11,

                                            marginTop: 11,
                                          }}
                                        />
                                      </Dropzone>
                                    </Tooltip>
                                  </div>
                                </Grid>
                              </div>
                            </Grid>
                            <p
                              className="input-label"
                              style={{
                                marginBottom: 8,
                                paddingLeft: 8,
                                marginTop: -8,
                              }}
                            >
                              Note:<br></br>
                              Supported files: .gif, .jpeg, .jpg, .png, .pdf,
                              .xlsx, .xls, .doc and .docx<br></br>
                              Max size: 10MB
                            </p>
                          </Grid>
                          <ReactQuill
                            theme="snow"
                            value={this.state.noticeData.noticedetails || ""}
                            modules={modules}
                            formats={formats}
                            onChange={(value) => {
                              this.handleChange1("noticedetails", value);
                            }}
                            placeholder="Enter notice details"
                            style={{ marginTop: 8 }}
                          />
                        </div>

                        <Grid
                          container
                          style={{
                            justifyContent: "space-between",
                            alignItems: "center",
                            marginTop: 16,
                          }}
                          spacing={2}
                        >
                          <Grid item sm={12} md={4}>
                            <div className="margin-bottom-16">
                              <Tooltip
                                title={`Notices will be hidden under "Old notice" after its visible until date.`}
                                placement="top"
                              >
                                <p className="input-label">
                                  Notice visible until ℹ️
                                </p>
                              </Tooltip>
                              <DatePickerComponent
                                // placeholder="From Date"
                                min={new Date()}
                                max={this.state.maxnoticedate}
                                id="startDate"
                                // allowEdit
                                value={this.state.noticeData.visibleuntil}
                                format={getEJ2CalenderDateFormat()}
                                // min={this.state.minApplyDate}
                                change={(val) =>
                                  this.handleDateChange("visibleuntil", val)
                                }
                                hideClearIcon={true}
                              />
                            </div>
                          </Grid>
                          <Grid item sm={12} md={4}>
                            <Tooltip
                              title="This feature allows you to make a specific notice to be mandatorily read and acknowledged by each employee. Mandatory notices are shown to employees as soon as they login into sumHR and cannot skip acknowledging it."
                              placement="top"
                            >
                              <p className="input-label margin-right-4">
                                Mandate acknowledgment ℹ️
                              </p>
                            </Tooltip>
                            <DynamicForm
                              fields={selectinputconverter({
                                value: this.state.isackrequired,
                                label: "",
                                placeholder: "No",
                                options: this.state.acknowledgmenttypes,
                              })}
                              onChange={(id) =>
                                this.handleChange1("isackrequired", id)
                              }
                            />
                          </Grid>
                          <Grid item sm={12} md={4}>
                            <Tooltip
                              title="You can share a notice with all employees or employees of a specific department. Notices are only visible to employees you choose in this setting."
                              placement="top"
                            >
                              <p className="input-label margin-right-4">
                                Notice visibility ℹ️
                              </p>
                            </Tooltip>
                            <DynamicForm
                              fields={selectinputconverter({
                                value: this.state.sharedid,

                                label: "",
                                placeholder: "Everyone",
                                options: this.state.sharedtypes,
                              })}
                              onChange={(id) =>
                                this.handleChange1("sharedid", id)
                              }
                            />
                          </Grid>
                        </Grid>
                        {this.state.sharedid == 2 && (
                          <div item sm={12} md={4} className="margin-bottom-16">
                            <p className="input-label">Department</p>
                            <Select
                              isMulti
                              className="selectsearch"
                              onChange={(id) =>
                                this.handleChange1("selectedDepartementIds", id)
                              }
                              options={this.state.alldepartmentslist}
                              getOptionLabel={(option) => option.displayname}
                              getOptionValue={(option) => option.displayvalue}
                              value={this.state.selectedDepartment}
                              placeholder="Select department"
                            />
                          </div>
                        )}

                        <Grid container>
                          <Grid
                            item
                            sm={12}
                            md={12}
                            // style={{ textAlign: "right" }}
                          >
                            <div>
                              <Button
                                variant="contained"
                                className="btn btn-primary-sm-blue"
                                onClick={this.createNotice}
                              >
                                Publish
                              </Button>
                              <Button
                                variant="contained"
                                className="btn btn-trans margin-left-16"
                                onClick={() =>
                                  this.setState({ isnewnotice: false })
                                }
                              >
                                Cancel
                              </Button>
                            </div>
                          </Grid>
                        </Grid>
                      </Paper>
                    )}

                    {this.state.loadingnotices ? (
                      <Paper className="rounded-rectangle-paper margin-bottom-24">
                        <div className="pre-loader" style={{ height: 100 }}>
                          Loading...
                        </div>
                      </Paper>
                    ) : (
                      <div>
                        {this.state.allNotices &&
                        this.state.allNotices.length > 0 ? (
                          <div>
                            {this.state.allNotices.map((notice) => (
                              <Paper
                                className="rounded-rectangle-paper padding16 margin-bottom-16 cursor-pointer"
                                onClick={() => this.getnoticedetails(notice)}
                              >
                                <div
                                  className="display-flex"
                                  style={{
                                    justifyContent: "space-between",
                                    alignItems: "center",
                                  }}
                                >
                                  <div style={{ width: "80%" }}>
                                    {notice.ispinned &&
                                      this.state.isoldnotices && (
                                        <p className="normal-dark">📌</p>
                                      )}
                                    <p className="normal-dark-secondary ellipsis width90 t-bold">
                                      {notice.notice}
                                    </p>
                                    <p
                                      className="normal-dark-secondary ellipsis width90 notice-deatils last-conversation"
                                      dangerouslySetInnerHTML={{
                                        __html: notice.noticedetails,
                                      }}
                                      style={{ height: 20 }}
                                    >
                                      {/* {notice.noticedetails} */}
                                    </p>
                                  </div>
                                  <div
                                    className="display-flex"
                                    style={{ alignItems: "center" }}
                                  >
                                    {notice.attachment &&
                                      notice.attachment.length > 0 &&
                                      notice.attachment[0].filename != null && (
                                        <img
                                          src={attachmentIcon}
                                          height="16"
                                          width="16"
                                          style={{ marginRight: 32 }}
                                        ></img>
                                      )}
                                    {notice.isackrequired &&
                                    !notice.isempack ? (
                                      <Button
                                        variant="contained"
                                        className="btn btn-secondary-md-blue"
                                        // onClick={() => this.reactToNotice(notice)}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.reactToNotice(
                                            notice.noticeboardid,
                                            99,
                                          );
                                        }}
                                      >
                                        Acknowledge
                                      </Button>
                                    ) : (
                                      <div
                                        className="display-flex notice-reaction-div"
                                        style={{ alignItems: "center" }}
                                        onClick={(e) => {
                                          e.stopPropagation();
                                          this.openReactionDrawer(
                                            notice.noticeboardid,
                                          );
                                        }}
                                      >
                                        {notice.reaction &&
                                          notice.reaction.length > 0 &&
                                          notice.reaction[0].count != 0 && (
                                            <p
                                              className="large-text-dark-secondary margin-right-8"
                                              // onClick={(e) => {
                                              //   e.stopPropagation();
                                              //   this.openReactionDrawer(
                                              //     notice.noticeboardid,
                                              //   );
                                              // }}
                                            >
                                              {notice.reaction &&
                                                notice.reaction.length > 0 &&
                                                notice.reaction[0].count}
                                            </p>
                                          )}
                                        <img
                                          src={thumbsupicon}
                                          height="24"
                                          width="24"
                                          // onClick={(e) => {
                                          //   e.stopPropagation();
                                          //   this.reactToNotice(
                                          //     notice.noticeboardid,
                                          //     1,
                                          //   );
                                          // }}
                                          // style={{ padding: 8 }}
                                        ></img>
                                      </div>
                                    )}
                                  </div>
                                </div>
                              </Paper>
                            ))}
                          </div>
                        ) : (
                          <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                            <p className="normal-dark">
                              {this.state.isoldnotices
                                ? "No new notices"
                                : "No old notices"}
                            </p>
                          </Paper>
                        )}
                      </div>
                    )}

                    {/* {this.state.allNotices &&
                      this.state.allNotices.length == 0 && (
                        <Paper className="rounded-rectangle-paper padding16 margin-bottom-16">
                          <p className="normal-dark">No new notices</p>
                        </Paper>
                      )} */}

                    <div style={{ textAlign: "right", marginBottom: 16 }}>
                      {/* <Button
                        variant="contained"
                        className="btn btn-primary-md-blue margin-bottom-16"
                        onClick={() => this.getNotice(true)}
                      >
                        Load old notices
                      </Button> */}
                      {this.state.isoldnotices ? (
                        <p
                          className="view-more-link"
                          style={{ textAlign: "right" }}
                          onClick={() => {
                            this.setState(
                              { isoldnotices: false },
                              this.getNotice(true),
                            );
                          }}
                        >
                          {" "}
                          View old notices
                        </p>
                      ) : (
                        <p
                          className="view-more-link"
                          style={{ textAlign: "right" }}
                          onClick={() => {
                            this.setState(
                              { isoldnotices: true },
                              this.getNotice(false),
                            );
                          }}
                        >
                          {" "}
                          View new notices
                        </p>
                      )}
                    </div>
                  </div>

                  {(this.state.isindepartment ||
                    this.state.isdeptshowtime ||
                    this.state.isinorganization ||
                    this.state.isorgshowtime ||
                    this.state.iscaldepartment ||
                    this.state.iscalorganization ||
                    this.state.ismanager ||
                    (this.props.AuthenticationAction &&
                      this.props.AuthenticationAction.login &&
                      this.props.AuthenticationAction.login.masterprofileid &&
                      this.props.AuthenticationAction.login.masterprofileid ==
                        9)) && (
                    <div>
                      {this.state.loading == true ? (
                        <Paper className="rounded-rectangle-paper margin-bottom-24">
                          {this.showLoader()}
                        </Paper>
                      ) : (
                        <>
                          <Grid
                            item
                            xs={12}
                            md={12}
                            sm={12}
                            justify="flex-start"
                            className="display-flex"
                          >
                            <div
                              style={{
                                marginBottom: 16,
                                display: "flex",
                                justifyContent: "space-between",
                                width: "100%",
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  justifyContent: "space-between",
                                  alignItems: "center",
                                }}
                              >
                                <p className="margin-right-16 small-dark t-bold">
                                  Who's in today @{" "}
                                  {this.state.empfilterid == 1
                                    ? "my direct report"
                                    : this.state.empfilterid == 2
                                    ? "my department"
                                    : "company-wide"}
                                </p>
                                <div className="">
                                  <SearchSq
                                    placeholder="Search"
                                    value={this.state.searchValue1}
                                    onChange={this.handleSearch}
                                  />
                                </div>
                              </div>
                              <div
                                className="display-flex"
                                style={{
                                  cursor: "pointer",
                                  width: 100,
                                  alignItems: "center",
                                  justifyContent: "center",
                                  border: "solid 1px #d9dadb",
                                  borderRadius: 4,
                                }}
                                onClick={this.onSortMenuClick}
                              >
                                <img
                                  src={filterIcon}
                                  className="margin-right-8"
                                  style={{
                                    color: "#1e8ced",
                                    fontWeight: "bold",
                                    fontSize: 14,
                                  }}
                                ></img>
                                <span style={{ color: "#1e8ced" }}>Filter</span>
                                <Popover
                                  open={this.state.sortmenu}
                                  anchorEl={this.state.sort_anchorEl}
                                  anchorOrigin={{
                                    vertical: "bottom",
                                    horizontal: "right",
                                  }}
                                  transformOrigin={{
                                    vertical: "top",
                                    horizontal: "right",
                                  }}
                                  // onClose={() =>
                                  //   this.setState({
                                  //     sortmenu: false,
                                  //     sort_anchorEl: null,
                                  //   })
                                  // }
                                  // onClick={this.closePopper}
                                  className="margin-top-8"
                                >
                                  <Paper style={{ width: 180 }}>
                                    {/* <ClickAwayListener
                              onClickAway={() =>
                                this.setState({
                                  sortmenu: false,
                                })
                              }
                            > */}
                                    <div>
                                      <List>
                                        {this.state.ismanager && (
                                          <ListItem
                                            button
                                            selected={
                                              this.state.empfilterid == 1
                                                ? true
                                                : false
                                            }
                                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                            onClick={() =>
                                              this.setState(
                                                {
                                                  empfilterid: 1,
                                                  loading: true,
                                                  sortmenu: false,
                                                  sort_anchorEl: null,
                                                },
                                                () => this.onFloormydesk(),
                                              )
                                            }
                                          >
                                            {/* <ListItemIcon>
                            <img src={userIcon}></img>
                          </ListItemIcon> */}
                                            <ListItemText
                                              style={{ padding: 0 }}
                                            >
                                              <span className="small-dark-secondary">
                                                Direct reports
                                              </span>
                                            </ListItemText>
                                          </ListItem>
                                        )}
                                        {(this.state.isindepartment ||
                                          (this.props.AuthenticationAction &&
                                            this.props.AuthenticationAction
                                              .login &&
                                            this.props.AuthenticationAction
                                              .login.masterprofileid &&
                                            this.props.AuthenticationAction
                                              .login.masterprofileid == 9)) && (
                                          <ListItem
                                            button
                                            selected={
                                              this.state.empfilterid == 2
                                                ? true
                                                : false
                                            }
                                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                            onClick={() =>
                                              this.setState(
                                                {
                                                  empfilterid: 2,
                                                  loading: true,
                                                  sortmenu: false,
                                                  sort_anchorEl: null,
                                                },
                                                () => this.onFloormydesk(),
                                              )
                                            }
                                          >
                                            <ListItemText
                                              style={{ padding: 0 }}
                                            >
                                              <span className="small-dark-secondary">
                                                My department
                                              </span>
                                            </ListItemText>
                                          </ListItem>
                                        )}
                                        {((this.props.AuthenticationAction &&
                                          this.props.AuthenticationAction
                                            .login &&
                                          this.props.AuthenticationAction.login
                                            .masterprofileid &&
                                          this.props.AuthenticationAction.login
                                            .masterprofileid == 9) ||
                                          this.state.isinorganization) && (
                                          <ListItem
                                            button
                                            selected={
                                              this.state.empfilterid == 3
                                                ? true
                                                : false
                                            }
                                            className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                            onClick={() =>
                                              this.setState(
                                                {
                                                  empfilterid: 3,
                                                  loading: true,
                                                  sortmenu: false,
                                                  sort_anchorEl: null,
                                                },
                                                () => this.onFloormydesk(),
                                              )
                                            }
                                          >
                                            <ListItemText
                                              style={{ padding: 0 }}
                                            >
                                              <span className="small-dark-secondary">
                                                Organization
                                              </span>
                                            </ListItemText>
                                          </ListItem>
                                        )}
                                        <Divider />
                                        <ListItem
                                          button
                                          className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                          // onClick={() =>
                                          //   this.setState(
                                          //     {
                                          //       objectivedropdownname: "Individual",
                                          //       objectivetypeid: 5,
                                          //     },
                                          //     () => this.getOkrData(null, true, 5),
                                          //   )
                                          // }
                                        >
                                          <ListItemIcon>
                                            <Checkbox
                                              edge="start"
                                              checked={this.state.isclockin}
                                              tabIndex={-1}
                                              disableRipple
                                              onChange={(e) =>
                                                this.setState({
                                                  isclockin:
                                                    !this.state.isclockin,
                                                })
                                              }
                                              inputProps={{}}
                                            />
                                          </ListItemIcon>
                                          <ListItemText style={{ padding: 0 }}>
                                            <span className="small-dark-secondary">
                                              In
                                            </span>
                                          </ListItemText>
                                        </ListItem>
                                        <ListItem
                                          button
                                          className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                          // onClick={() => this.handleClick(2, "Department")}
                                        >
                                          <ListItemIcon>
                                            <Checkbox
                                              edge="start"
                                              checked={this.state.isclockout}
                                              tabIndex={-1}
                                              onChange={(e) =>
                                                this.setState({
                                                  isclockout:
                                                    !this.state.isclockout,
                                                  isfilterapply: true,
                                                })
                                              }
                                              disableRipple
                                              inputProps={{}}
                                            />
                                          </ListItemIcon>
                                          <ListItemText style={{ padding: 0 }}>
                                            <span className="small-dark-secondary">
                                              Out
                                            </span>
                                          </ListItemText>
                                          {/* <ListItemSecondaryAction
                            onClick={() => this.handleClick(2, "Department")}
                          >
                            <img src={rightArrow} className="vertical-middle" />
                          </ListItemSecondaryAction> */}
                                        </ListItem>
                                        <ListItem
                                          button
                                          className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                          // onClick={() => this.handleClick(3, "Team")}
                                        >
                                          <ListItemIcon>
                                            <Checkbox
                                              edge="start"
                                              checked={this.state.isnotclockin}
                                              tabIndex={-1}
                                              disableRipple
                                              onChange={(e) =>
                                                this.setState({
                                                  isnotclockin:
                                                    !this.state.isnotclockin,
                                                })
                                              }
                                              inputProps={{}}
                                            />
                                          </ListItemIcon>
                                          <ListItemText style={{ padding: 0 }}>
                                            <span className="small-dark-secondary">
                                              Not clocked-in
                                            </span>
                                          </ListItemText>
                                        </ListItem>
                                        <ListItem
                                          button
                                          className="padding-right-0 padding-top-4 padding-bottom-4 cursor-pointer"
                                          // onClick={() => this.handleClick(1, "Business unit")}
                                        >
                                          <ListItemIcon>
                                            <Checkbox
                                              edge="start"
                                              checked={this.state.isonleave}
                                              tabIndex={-1}
                                              disableRipple
                                              onChange={(e) =>
                                                this.setState({
                                                  isonleave:
                                                    !this.state.isonleave,
                                                })
                                              }
                                              inputProps={{}}
                                            />
                                          </ListItemIcon>
                                          <ListItemText style={{ padding: 0 }}>
                                            <span className="small-dark-secondary">
                                              Today on leave
                                            </span>
                                          </ListItemText>
                                        </ListItem>
                                      </List>
                                    </div>
                                    {/* </ClickAwayListener> */}
                                  </Paper>
                                </Popover>
                              </div>
                              {/* <div className="floatleft margin-right-16" style={{ width: 160 }}>
                <DynamicForm
                  fields={selectinputconverter({
                    value: this.state.statusids,
                    placeholder: "Select status",
                    label: "",
                    options: this.state.exceptionStatus,
                  })}
                  onChange={(value) => {
                    this.onFilterValueChange(value, "statusids");
                  }}
                />
              </div> */}
                            </div>
                          </Grid>
                          <Grid container className="display-flex">
                            <Grid
                              item
                              xs={12}
                              md={12}
                              sm={12}
                              style={{ marginBottom: 16 }}
                            >
                              {this.state.isnotclockin == true &&
                                ((this.state.issearch == true &&
                                  withoutclockin.length > 0) ||
                                  this.state.issearch == false) && (
                                  <Paper
                                    className="rounded-rectangle-paper padding16 margin-bottom-16"
                                    style={{
                                      borderLeft: "solid 4px #ff4052",
                                      maxHeight: 100,
                                    }}
                                  >
                                    <div className="display-flex">
                                      <p className="small-dark t-bold">
                                        Not clocked-in yet
                                      </p>
                                      {withoutclockin.length == 0 && (
                                        <p
                                          className="small-dark-secondary margin-left-16 padding-left-16"
                                          style={{
                                            borderLeft: "solid 1px #545556",
                                            color: "#545556",
                                          }}
                                        >
                                          All employees have clocked-in or out
                                          for the day.
                                        </p>
                                      )}
                                    </div>
                                    {withoutclockin.length > 0 && (
                                      <div className="margin-top-8 position-rel">
                                        <Grid
                                          container
                                          className="avtar-thumb-wrapper"
                                          style={{
                                            height: 50,
                                            float: "unset",
                                            marginLeft: 0,
                                            display: "flex",
                                            justifyContent: "start",
                                          }}
                                        >
                                          {withoutclockin.map((emp, index) => (
                                            <>
                                              {index < 10 ? (
                                                <Grid
                                                  item
                                                  md={1}
                                                  sm={1}
                                                  className={
                                                    this.getCount(
                                                      withoutclockin.length,
                                                    ) > 0
                                                      ? "avtar-thumb-blur"
                                                      : "avtar-thumb"
                                                  }
                                                  key="key"
                                                  style={{
                                                    height: 60,
                                                    width: 60,
                                                    marginLeft: 0,
                                                    marginRight: 8,
                                                    textAlign: "center",
                                                  }}
                                                >
                                                  <Tooltip
                                                    title={emp.fullname}
                                                    placement="top"
                                                  >
                                                    <div
                                                      className="avatar-wrapper cursour-pointer"
                                                      // onClick={(e) =>
                                                      //   this.onProfileDetails(
                                                      //     emp.employeeid,
                                                      //     e,
                                                      //     index,
                                                      //     "withoutclockin",
                                                      //   )
                                                      // }
                                                      style={{
                                                        height: 60,
                                                        width: 60,
                                                        border: "none",
                                                        float: "unset",
                                                      }}
                                                    >
                                                      {emp.imagepath == null ? (
                                                        <img
                                                          src={defaultEmp}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "withoutclockin",
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        <img
                                                          src={getFormattedImageLink(
                                                            emp.imagepath,
                                                          )}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "withoutclockin",
                                                            )
                                                          }
                                                        />
                                                      )}
                                                      {this.getCount(
                                                        withoutclockin.length,
                                                      ) > 0 ? (
                                                        <div
                                                          className="count-overlay"
                                                          onClick={() =>
                                                            this.setState(
                                                              {
                                                                isdraweropen: true,
                                                                tabvalue: 0,
                                                              },
                                                              () =>
                                                                this.GetAllLocationList(),
                                                            )
                                                          }
                                                        >
                                                          <span>
                                                            <div
                                                              className="total-count"
                                                              style={{
                                                                top: 13,
                                                                fontSize: 11,
                                                              }}
                                                            >
                                                              +
                                                              {this.getCount(
                                                                withoutclockin.length,
                                                              )}
                                                            </div>
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </Tooltip>
                                                </Grid>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ))}
                                          {this.state.profiledetail && (
                                            <Popover
                                              open={this.state.profiledetail}
                                              anchorEl={
                                                this.state
                                                  .profiledetail_anchorEl
                                              }
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                              }}
                                              transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                              }}
                                              onClose={() =>
                                                this.setState({
                                                  profiledetail: false,
                                                  profiledetaildata: [],
                                                })
                                              }
                                              className="thin-scroll"
                                              style={{ maxHeight: 400 }}
                                            >
                                              <Paper
                                                className="objective-wrapper"
                                                style={{
                                                  boxShadow:
                                                    "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                                                  width: 250,
                                                  display: "flex",
                                                  // backgroundColor: "red",
                                                }}
                                              >
                                                <div style={{}}>
                                                  <div
                                                    style={{
                                                      height: 180,
                                                      width: 250,
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        height: "100%",
                                                        position: "absolute",
                                                        width: "100%",
                                                        backgroundImage:
                                                          "linear-gradient(to bottom, rgba(1, 7, 9, 0), #010709)",
                                                      }}
                                                    ></div>
                                                    <img
                                                      src={getFormattedImageLink(
                                                        profiledetaildata.imagepath,
                                                      )}
                                                      style={{
                                                        objectFit: "cover",
                                                        width: "100%",
                                                        height: "100%",
                                                      }}
                                                    ></img>
                                                    <div
                                                      className="display-flex"
                                                      style={{
                                                        justifyContent:
                                                          "space-between",

                                                        position: "absolute",
                                                        width:
                                                          "calc(100% - 32px)",
                                                        padding: 16,
                                                        bottom: 0,
                                                      }}
                                                    >
                                                      <span
                                                        className="normal-dark width75 t-bold ellipsis display-block"
                                                        style={{
                                                          color: "#fff",
                                                        }}
                                                      >
                                                        {
                                                          profiledetaildata.fullname
                                                        }
                                                      </span>
                                                      <Link
                                                        to={`./profile/${profiledetaildata.employeeid}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <img src={newTab}></img>
                                                      </Link>
                                                    </div>
                                                  </div>

                                                  <div className="padding16">
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.designationname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.designationname
                                                          }
                                                          img={designation}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.primarymobile
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.primarymobile
                                                          }
                                                          img={phone}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.emailid
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.emailid
                                                          }
                                                          img={emailIcon}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.departmentname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.departmentname
                                                          }
                                                          img={department}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </Paper>
                                            </Popover>
                                          )}
                                        </Grid>
                                      </div>
                                    )}
                                  </Paper>
                                )}

                              {this.state.isclockout == true &&
                                ((this.state.issearch == true &&
                                  clockout.length > 0) ||
                                  this.state.issearch == false) && (
                                  <Paper
                                    className="rounded-rectangle-paper padding16 margin-bottom-16"
                                    style={{
                                      borderLeft: "solid 4px #faa500",
                                      maxHeight: 100,
                                    }}
                                  >
                                    <div className="display-flex">
                                      <p className="small-dark t-bold">
                                        Clocked-out
                                      </p>
                                      {clockout.length == 0 && (
                                        <p
                                          className="small-dark-secondary margin-left-16 padding-left-16"
                                          style={{
                                            borderLeft: "solid 1px #545556",
                                            color: "#545556",
                                          }}
                                        >
                                          No employee clocked-out yet
                                        </p>
                                      )}
                                    </div>
                                    {clockout.length > 0 && (
                                      <div className="margin-top-8 position-rel">
                                        <Grid
                                          container
                                          className="avtar-thumb-wrapper"
                                          style={{
                                            height:
                                              this.state.isdeptshowtime &&
                                              this.state.empfilterid == 2
                                                ? 72
                                                : this.state.isorgshowtime &&
                                                  this.state.empfilterid == 3
                                                ? 72
                                                : this.props
                                                    .AuthenticationAction &&
                                                  this.props
                                                    .AuthenticationAction
                                                    .login &&
                                                  this.props
                                                    .AuthenticationAction.login
                                                    .masterprofileid &&
                                                  this.props
                                                    .AuthenticationAction.login
                                                    .masterprofileid == 9
                                                ? 72
                                                : 50,
                                            float: "unset",
                                            marginLeft: 0,
                                            display: "flex",
                                            justifyContent: "start",
                                          }}
                                        >
                                          {clockout.map((emp, index) => (
                                            <>
                                              {index < 10 ? (
                                                <Grid
                                                  item
                                                  md={1}
                                                  sm={1}
                                                  className={
                                                    this.getCount(
                                                      clockout.length,
                                                    ) > 0
                                                      ? "avtar-thumb-blur"
                                                      : "avtar-thumb"
                                                  }
                                                  style={{
                                                    height: 60,
                                                    width: 60,
                                                    marginLeft: 0,
                                                    marginRight: 8,
                                                    textAlign: "center",
                                                  }}
                                                  key="key"
                                                >
                                                  <Tooltip
                                                    title={emp.fullname}
                                                    placement="top"
                                                  >
                                                    <div
                                                      className="avatar-wrapper cursour-pointer"
                                                      // onClick={(e) =>
                                                      //   this.onProfileDetails(
                                                      //     emp.employeeid,
                                                      //     e,
                                                      //     index,
                                                      //     "clockout",
                                                      //   )
                                                      // }
                                                      style={{
                                                        height: 60,
                                                        width: 60,
                                                        border: "none",
                                                        float: "unset",
                                                      }}
                                                    >
                                                      {emp.imagepath == null ? (
                                                        <img
                                                          src={defaultEmp}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "clockout",
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        <img
                                                          src={getFormattedImageLink(
                                                            emp.imagepath,
                                                          )}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "clockout",
                                                            )
                                                          }
                                                        />
                                                      )}
                                                      {emp.outtime && (
                                                        <p
                                                          className="extra-small-dark-secondary margin-top-8"
                                                          style={{
                                                            fontSize: 9,
                                                          }}
                                                        >
                                                          {moment(
                                                            emp.outtime,
                                                            "HH:mm:ss",
                                                          ).format(
                                                            "hh:mm:ss A",
                                                          )}
                                                          {/* {getFormattedTime(emp.outtime)} */}
                                                        </p>
                                                      )}

                                                      {this.getCount(
                                                        clockout.length,
                                                      ) > 0 ? (
                                                        <div
                                                          className="count-overlay"
                                                          onClick={() =>
                                                            this.setState(
                                                              {
                                                                isdraweropen: true,
                                                                tabvalue: 1,
                                                              },
                                                              () =>
                                                                this.GetAllLocationList(),
                                                            )
                                                          }
                                                        >
                                                          <span>
                                                            <div
                                                              className="total-count"
                                                              style={{
                                                                top: 13,
                                                                fontSize: 11,
                                                              }}
                                                            >
                                                              +
                                                              {this.getCount(
                                                                clockout.length,
                                                              )}
                                                            </div>
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </Tooltip>
                                                </Grid>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ))}
                                          {this.state.profiledetail1 && (
                                            <Popover
                                              open={this.state.profiledetail1}
                                              anchorEl={
                                                this.state
                                                  .profiledetail1_anchorEl
                                              }
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                              }}
                                              transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                              }}
                                              onClose={() =>
                                                this.setState({
                                                  profiledetail1: false,
                                                  profiledetaildata: [],
                                                })
                                              }
                                              className="thin-scroll"
                                              style={{ maxHeight: 400 }}
                                            >
                                              <Paper
                                                className="objective-wrapper"
                                                style={{
                                                  boxShadow:
                                                    "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                                                  width: 250,
                                                  display: "flex",
                                                  // backgroundColor: "yellow",
                                                }}
                                              >
                                                <div style={{}}>
                                                  <div
                                                    style={{
                                                      height: 180,
                                                      width: 250,
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        height: "100%",
                                                        position: "absolute",
                                                        width: "100%",
                                                        backgroundImage:
                                                          "linear-gradient(to bottom, rgba(1, 7, 9, 0), #010709)",
                                                      }}
                                                    ></div>
                                                    <img
                                                      src={getFormattedImageLink(
                                                        profiledetaildata.imagepath,
                                                      )}
                                                      style={{
                                                        objectFit: "cover",
                                                        width: "100%",
                                                        height: "100%",
                                                      }}
                                                    ></img>
                                                    <div
                                                      className="display-flex"
                                                      style={{
                                                        justifyContent:
                                                          "space-between",

                                                        position: "absolute",
                                                        width:
                                                          "calc(100% - 32px)",
                                                        padding: 16,
                                                        bottom: 0,
                                                      }}
                                                    >
                                                      <span
                                                        className="normal-dark width75 t-bold ellipsis display-block"
                                                        style={{
                                                          color: "#fff",
                                                        }}
                                                      >
                                                        {
                                                          profiledetaildata.fullname
                                                        }
                                                      </span>
                                                      <Link
                                                        to={`./profile/${profiledetaildata.employeeid}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <img src={newTab}></img>
                                                      </Link>
                                                    </div>
                                                  </div>

                                                  <div className="padding16">
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.designationname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.designationname
                                                          }
                                                          img={designation}
                                                          labelClassNames="small-dark-secondary width80 ellipsis "
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.primarymobile
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.primarymobile
                                                          }
                                                          img={phone}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.emailid
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.emailid
                                                          }
                                                          img={emailIcon}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.departmentname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.departmentname
                                                          }
                                                          img={department}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </Paper>
                                            </Popover>
                                          )}
                                        </Grid>
                                      </div>
                                    )}
                                  </Paper>
                                )}

                              {this.state.isclockin == true &&
                                ((this.state.issearch == true &&
                                  clockin.length > 0) ||
                                  this.state.issearch == false) && (
                                  <Paper
                                    className="rounded-rectangle-paper padding16 margin-bottom-16"
                                    style={{
                                      borderLeft: "solid 4px #1E8CED",
                                      maxmaxHeight: 100,
                                    }}
                                  >
                                    <div className="display-flex">
                                      <p className="small-dark t-bold">
                                        Clocked-in
                                      </p>
                                      {clockin.length == 0 && (
                                        <p
                                          className="small-dark-secondary margin-left-16 padding-left-16"
                                          style={{
                                            borderLeft: "solid 1px #545556",
                                            color: "#545556",
                                          }}
                                        >
                                          No employee clocked-in yet
                                        </p>
                                      )}
                                    </div>

                                    {clockin.length > 0 && (
                                      <div className="margin-top-8 position-rel">
                                        <Grid
                                          container
                                          className="avtar-thumb-wrapper"
                                          style={{
                                            height:
                                              this.state.isdeptshowtime &&
                                              this.state.empfilterid == 2
                                                ? 72
                                                : this.state.isorgshowtime &&
                                                  this.state.empfilterid == 3
                                                ? 72
                                                : this.props
                                                    .AuthenticationAction &&
                                                  this.props
                                                    .AuthenticationAction
                                                    .login &&
                                                  this.props
                                                    .AuthenticationAction.login
                                                    .masterprofileid &&
                                                  this.props
                                                    .AuthenticationAction.login
                                                    .masterprofileid == 9
                                                ? 72
                                                : 50,
                                            float: "unset",
                                            marginLeft: 0,
                                            display: "flex",
                                            justifyContent: "start",
                                          }}
                                        >
                                          {clockin.map((emp, index) => (
                                            <>
                                              {index < 10 ? (
                                                <Grid
                                                  item
                                                  md={1}
                                                  sm={1}
                                                  className={
                                                    this.getCount(
                                                      clockin.length,
                                                    ) > 0
                                                      ? "avtar-thumb-blur"
                                                      : "avtar-thumb"
                                                  }
                                                  style={{
                                                    height: 60,
                                                    width: 60,
                                                    marginLeft: 0,
                                                    marginRight: 8,
                                                    textAlign: "center",
                                                  }}
                                                  key="key"
                                                >
                                                  <Tooltip
                                                    title={emp.fullname}
                                                    placement="top"
                                                  >
                                                    <div
                                                      className="avatar-wrapper cursour-pointer"
                                                      // onClick={(e) =>
                                                      //   this.onProfileDetails(
                                                      //     emp.employeeid,
                                                      //     e,
                                                      //     index,
                                                      //     "clockin",
                                                      //   )
                                                      // }
                                                      style={{
                                                        height: 60,
                                                        width: 60,
                                                        border: "none",
                                                        float: "unset",
                                                      }}
                                                    >
                                                      {emp.imagepath == null ? (
                                                        <img
                                                          src={defaultEmp}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "clockin",
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        <img
                                                          src={getFormattedImageLink(
                                                            emp.imagepath,
                                                          )}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "clockin",
                                                            )
                                                          }
                                                        />
                                                      )}
                                                      {emp.intime && (
                                                        <p
                                                          className="extra-small-dark-secondary margin-top-8"
                                                          style={{
                                                            fontSize: 9,
                                                          }}
                                                        >
                                                          {/* {getFormattedTime(emp.intime)} */}
                                                          {moment(
                                                            emp.intime,
                                                            "HH:mm:ss",
                                                          ).format(
                                                            "hh:mm:ss A",
                                                          )}
                                                        </p>
                                                      )}
                                                      {this.getCount(
                                                        clockin.length,
                                                      ) > 0 ? (
                                                        <div
                                                          className="count-overlay"
                                                          onClick={() =>
                                                            this.setState(
                                                              {
                                                                isdraweropen: true,
                                                                tabvalue: 2,
                                                              },
                                                              () =>
                                                                this.GetAllLocationList(),
                                                            )
                                                          }
                                                        >
                                                          <span>
                                                            <div
                                                              className="total-count"
                                                              style={{
                                                                top: 13,
                                                                fontSize: 11,
                                                              }}
                                                            >
                                                              +
                                                              {this.getCount(
                                                                clockin.length,
                                                              )}
                                                            </div>
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </Tooltip>
                                                </Grid>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ))}
                                          {this.state.profiledetail2 && (
                                            <Popover
                                              open={this.state.profiledetail2}
                                              anchorEl={
                                                this.state
                                                  .profiledetail2_anchorEl
                                              }
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                              }}
                                              transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                              }}
                                              onClose={() =>
                                                this.setState({
                                                  profiledetail2: false,
                                                  profiledetaildata: [],
                                                })
                                              }
                                              className="thin-scroll"
                                              style={{ maxHeight: 400 }}
                                            >
                                              <Paper
                                                className="objective-wrapper"
                                                style={{
                                                  boxShadow:
                                                    "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                                                  width: 250,
                                                  display: "flex",
                                                  // backgroundColor: "green",
                                                }}
                                              >
                                                <div style={{}}>
                                                  <div
                                                    style={{
                                                      height: 180,
                                                      width: 250,
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        height: "100%",
                                                        position: "absolute",
                                                        width: "100%",
                                                        backgroundImage:
                                                          "linear-gradient(to bottom, rgba(1, 7, 9, 0), #010709)",
                                                      }}
                                                    ></div>
                                                    <img
                                                      src={getFormattedImageLink(
                                                        profiledetaildata.imagepath,
                                                      )}
                                                      style={{
                                                        objectFit: "cover",
                                                        width: "100%",
                                                        height: "100%",
                                                      }}
                                                    ></img>
                                                    <div
                                                      className="display-flex"
                                                      style={{
                                                        justifyContent:
                                                          "space-between",

                                                        position: "absolute",
                                                        width:
                                                          "calc(100% - 32px)",
                                                        padding: 16,
                                                        bottom: 0,
                                                      }}
                                                    >
                                                      <span
                                                        className="normal-dark width75 t-bold ellipsis display-block"
                                                        style={{
                                                          color: "#fff",
                                                        }}
                                                      >
                                                        {
                                                          profiledetaildata.fullname
                                                        }
                                                      </span>
                                                      <Link
                                                        to={`./profile/${profiledetaildata.employeeid}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <img src={newTab}></img>
                                                      </Link>
                                                    </div>
                                                  </div>

                                                  <div className="padding16">
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.designationname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.designationname
                                                          }
                                                          img={designation}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.primarymobile
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.primarymobile
                                                          }
                                                          img={phone}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.emailid
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.emailid
                                                          }
                                                          img={emailIcon}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.departmentname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.departmentname
                                                          }
                                                          img={department}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </Paper>
                                            </Popover>
                                          )}
                                        </Grid>
                                      </div>
                                    )}
                                  </Paper>
                                )}
                              {this.state.isonleave == true &&
                                ((this.state.issearch == true &&
                                  onleave.length > 0) ||
                                  this.state.issearch == false) && (
                                  <Paper
                                    className="rounded-rectangle-paper padding16 margin-bottom-16 padding-bottom-20"
                                    style={{
                                      borderLeft: "solid 4px #18aca7",
                                      maxHeight: 100,
                                    }}
                                  >
                                    <div className="display-flex">
                                      <p className="small-dark t-bold">
                                        On leave (or optional holiday) till{" "}
                                      </p>
                                      {onleave.length == 0 && (
                                        <p
                                          className="small-dark-secondary margin-left-16 padding-left-16"
                                          style={{
                                            borderLeft: "solid 1px #545556",
                                            color: "#545556",
                                          }}
                                        >
                                          No employee on leave
                                        </p>
                                      )}
                                    </div>
                                    {onleave.length > 0 && (
                                      <div className="margin-top-8 position-rel">
                                        <Grid
                                          container
                                          className="avtar-thumb-wrapper"
                                          style={{
                                            height: 60,
                                            float: "unset",
                                            marginLeft: 0,
                                            display: "flex",
                                            justifyContent: "start",
                                          }}
                                        >
                                          {onleave.map((emp, index) => (
                                            <>
                                              {index < 10 ? (
                                                <Grid
                                                  item
                                                  md={1}
                                                  sm={1}
                                                  className={
                                                    this.getCount(
                                                      onleave.length,
                                                    ) > 0
                                                      ? "avtar-thumb-blur"
                                                      : "avtar-thumb"
                                                  }
                                                  style={{
                                                    height: 60,
                                                    width: 32,
                                                    marginLeft: 0,
                                                    marginRight: 8,
                                                    textAlign: "center",
                                                  }}
                                                  key="key"
                                                >
                                                  <Tooltip
                                                    title={emp.fullname}
                                                    // title={
                                                    //   <div>
                                                    //     <p className="text-color-white margin-top-0 margin-bottom-4 t-11">
                                                    //       Employee name:{" "}
                                                    //       {emp.fullname}
                                                    //     </p>
                                                    //     {emp.holidayname && (
                                                    //       <p className="text-color-white margin-top-0 margin-bottom-4 t-11">
                                                    //         Holiday name:{" "}
                                                    //         {emp.holidayname}
                                                    //       </p>
                                                    //     )}
                                                    //   </div>
                                                    // }
                                                    placement="top"
                                                  >
                                                    <div
                                                      className="avatar-wrapper cursour-pointer"
                                                      // onClick={(e) =>
                                                      //   this.onProfileDetails(
                                                      //     emp.employeeid,
                                                      //     e,
                                                      //     index,
                                                      //     "onleave",
                                                      //   )
                                                      // }
                                                      style={{
                                                        height: 60,
                                                        width: 60,
                                                        border: "none",
                                                        float: "unset",
                                                      }}
                                                    >
                                                      {emp.imagepath == null ? (
                                                        <img
                                                          src={defaultEmp}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "onleave",
                                                            )
                                                          }
                                                        />
                                                      ) : (
                                                        <img
                                                          src={getFormattedImageLink(
                                                            emp.imagepath,
                                                          )}
                                                          height="48"
                                                          width="48"
                                                          className="team-avatar  margin-left-2"
                                                          onClick={(e) =>
                                                            this.onProfileDetails(
                                                              emp.employeeid,
                                                              e,
                                                              index,
                                                              "onleave",
                                                            )
                                                          }
                                                        />
                                                      )}
                                                      <div className="clear-float"></div>
                                                      <p
                                                        className=" extra-small-dark-secondary"
                                                        style={{
                                                          fontSize: 10,
                                                        }}
                                                      >
                                                        {moment(
                                                          emp.todate,
                                                        ).format(
                                                          "YYYY-MM-DD",
                                                        ) ==
                                                        moment(
                                                          new Date(),
                                                        ).format("YYYY-MM-DD")
                                                          ? "Today"
                                                          : getFormattedDaymonth(
                                                              emp.todate,
                                                            )}
                                                      </p>
                                                      {this.getCount(
                                                        onleave.length,
                                                      ) > 0 ? (
                                                        <div
                                                          className="count-overlay"
                                                          onClick={() =>
                                                            this.setState(
                                                              {
                                                                isdraweropen: true,
                                                                tabvalue: 3,
                                                              },
                                                              () =>
                                                                this.GetAllLocationList(),
                                                            )
                                                          }
                                                        >
                                                          <span>
                                                            <div
                                                              className="total-count"
                                                              style={{
                                                                top: 13,
                                                                fontSize: 11,
                                                              }}
                                                            >
                                                              +
                                                              {this.getCount(
                                                                onleave.length,
                                                              )}
                                                            </div>
                                                          </span>
                                                        </div>
                                                      ) : (
                                                        ""
                                                      )}
                                                    </div>
                                                  </Tooltip>
                                                </Grid>
                                              ) : (
                                                ""
                                              )}
                                            </>
                                          ))}
                                          {this.state.profiledetail3 && (
                                            <Popover
                                              open={this.state.profiledetail3}
                                              anchorEl={
                                                this.state
                                                  .profiledetail3_anchorEl
                                              }
                                              anchorOrigin={{
                                                vertical: "bottom",
                                                horizontal: "center",
                                              }}
                                              transformOrigin={{
                                                vertical: "top",
                                                horizontal: "center",
                                              }}
                                              onClose={() =>
                                                this.setState({
                                                  profiledetail3: false,
                                                  profiledetaildata: [],
                                                })
                                              }
                                              className="thin-scroll"
                                              style={{ maxHeight: 400 }}
                                            >
                                              <Paper
                                                className="objective-wrapper"
                                                style={{
                                                  boxShadow:
                                                    "0 3px 12px 0 rgba(0, 0, 0, 0.16)",
                                                  width: 250,
                                                  display: "flex",
                                                  // backgroundColor: "pink",
                                                }}
                                              >
                                                <div style={{}}>
                                                  <div
                                                    style={{
                                                      height: 180,
                                                      width: 250,
                                                      position: "relative",
                                                    }}
                                                  >
                                                    <div
                                                      style={{
                                                        height: "100%",
                                                        position: "absolute",
                                                        width: "100%",
                                                        backgroundImage:
                                                          "linear-gradient(to bottom, rgba(1, 7, 9, 0), #010709)",
                                                      }}
                                                    ></div>
                                                    <img
                                                      src={getFormattedImageLink(
                                                        profiledetaildata.imagepath,
                                                      )}
                                                      style={{
                                                        objectFit: "cover",
                                                        width: "100%",
                                                        height: "100%",
                                                      }}
                                                    ></img>
                                                    <div
                                                      className="display-flex"
                                                      style={{
                                                        justifyContent:
                                                          "space-between",

                                                        position: "absolute",
                                                        width:
                                                          "calc(100% - 32px)",
                                                        padding: 16,
                                                        bottom: 0,
                                                      }}
                                                    >
                                                      <span
                                                        className="normal-dark width75 t-bold ellipsis display-block"
                                                        style={{
                                                          color: "#fff",
                                                        }}
                                                      >
                                                        {
                                                          profiledetaildata.fullname
                                                        }
                                                      </span>
                                                      <Link
                                                        to={`./profile/${profiledetaildata.employeeid}`}
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                      >
                                                        <img src={newTab}></img>
                                                      </Link>
                                                    </div>
                                                  </div>

                                                  <div className="padding16">
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.designationname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.designationname
                                                          }
                                                          img={designation}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.primarymobile
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.primarymobile
                                                          }
                                                          img={phone}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.emailid
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="margin-bottom-8">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.emailid
                                                          }
                                                          img={emailIcon}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                    <Tooltip
                                                      title={
                                                        profiledetaildata.departmentname
                                                      }
                                                      placement="top"
                                                    >
                                                      <div className="">
                                                        <IconLabel
                                                          label={
                                                            profiledetaildata.departmentname
                                                          }
                                                          img={department}
                                                          labelClassNames="small-dark-secondary width80 ellipsis"
                                                          iconHeight="16"
                                                        />
                                                      </div>
                                                    </Tooltip>
                                                  </div>
                                                </div>
                                              </Paper>
                                            </Popover>
                                          )}
                                        </Grid>
                                      </div>
                                    )}
                                  </Paper>
                                )}
                            </Grid>
                          </Grid>
                        </>
                      )}
                    </div>
                  )}
                  {/* <Grid container className="display-flex">
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sm={12}
                      style={{ paddingRight: 8 }}
                    >
                      <div className="margin-bottom-16">
                        <LabelIcon
                          label="Attendance streak"
                          img={attendanceIcon}
                        />
                        <Paper
                          className="padding16"
                          style={{
                            height: 48,
                          }}
                        >
                          <div className="floatleft" style={{ width: "80%" }}>
                            <p className="input-label">
                              You've been on a roll for
                            </p>
                            <p className="t-bold large-text-dark-secondary">
                              {this.state.consistentstreak
                                ? this.state.consistentstreak
                                : 0}{" "}
                              days
                            </p>
                          </div>
                          <div className="floatright">
                            <span style={{ fontSize: 32 }}>
                              {this.state.consistentstreak
                                ? this.state.consistentstreak < 6
                                  ? "🙍‍♂"
                                  : this.state.consistentstreak > 5 &&
                                    this.state.consistentstreak < 11
                                  ? "👍"
                                  : this.state.consistentstreak > 10 &&
                                    this.state.consistentstreak < 26
                                  ? "👌️"
                                  : "🙌"
                                : "‍‍🙍‍♂️"}
                            </span>
                          </div>
                        </Paper>
                      </div>
                      <div>
                        <LabelIcon label="Extra time at work" img={clock} />
                        <Paper
                          className="padding16"
                          style={{
                            height: 48,
                          }}
                        >
                          <div className="floatleft" style={{ width: "80%" }}>
                            <p className="input-label">
                              You've burnt the midnight oil for
                            </p>
                            <p className="t-bold large-text-dark-secondary">
                              {this.state.totalovertimeminute
                                ? this.state.totalovertimeminute
                                : 0}{" "}
                              minutes
                            </p>
                          </div>
                          <div className="floatright">
                            <span style={{ fontSize: 32 }}>
                              {this.state.totalovertimeminute
                                ? this.state.totalovertimeminute < 61
                                  ? "😶"
                                  : this.state.totalovertimeminute > 60 &&
                                    this.state.totalovertimeminute < 301
                                  ? "😊"
                                  : "🌟"
                                : "‍‍😶"}
                            </span>
                          </div>
                        </Paper>
                      </div>
                    </Grid>
                    <Grid
                      item
                      xs={12}
                      md={6}
                      sm={12}
                      style={{ paddingLeft: 8 }}
                    >
                      <div className="margin-bottom-16">
                        <LabelIcon label="Late lately?" img={lateMark} />
                        <Paper
                          className="padding16"
                          style={{
                            height: 48,
                          }}
                        >
                          <div className="floatleft width60">
                            <p className="input-label">You've missed the bus</p>
                            <p className="t-bold large-text-dark-secondary">
                              {this.state.latemarkcount
                                ? this.state.latemarkcount
                                : 0}{" "}
                              times
                            </p>
                          </div>
                          <div className="floatright">
                            <span style={{ fontSize: 32 }}>
                              {this.state.latemarkcount
                                ? this.state.latemarkcount < 3
                                  ? "🐇"
                                  : this.state.latemarkcount > 2 &&
                                    this.state.latemarkcount < 6
                                  ? "🏃"
                                  : "🐢"
                                : "‍‍🐇"}
                            </span>
                          </div>
                        </Paper>
                      </div>
                      <div>
                        <LabelIcon label="Requests" img={requests} />
                        <Paper
                          className="padding16 cursour-pointer"
                          style={{
                            height: 48,
                          }}
                          onClick={() => window.open("/request_center")}
                        >
                          <div className="floatleft">
                            <p className="input-label">Pending Requests</p>
                            <p className="t-bold large-text-dark-secondary">
                              {this.state.pendingrequestcount
                                ? `${this.state.pendingrequestcount} Requests`
                                : "No Pending Requests"}
                            </p>
                          </div>
                          <div className="floatright">
                            <span
                              className="emoji-icon"
                              style={{ fontSize: 32 }}
                            >
                              📨
                            </span>
                          </div>
                        </Paper>
                      </div>
                    </Grid>
                  </Grid> */}
                </Grid>
                <Grid
                  item
                  xs={12}
                  md={4}
                  sm={12}
                  style={{ padding: "0px 12px 0px 12px" }}
                >
                  <LabelIcon
                    label="Share an idea to improve sumHR"
                    img={bulb}
                  />
                  <Paper
                    className="padding16 margin-bottom-16"
                    style={{
                      position: "relative",
                      // height: "78vh",
                      // height: 150,
                    }}
                  >
                    <div
                      style={
                        {
                          // position: "relative",
                          // top: "60%",
                          // transform: "translateY(-60%)",
                        }
                      }
                    >
                      {this.state.openForm ? (
                        this.state.success ? (
                          <div className="text-center">
                            <div className="sucess-gif">
                              <div>
                                <Lottie
                                  options={lottieObj}
                                  height={200}
                                  width={200}
                                />
                              </div>
                              <p align="center" className="sucessmessage1">
                                Thank you for your suggestions!
                              </p>
                            </div>
                            <div>
                              <br />
                              <p className="normal-dark-secondary text-center">
                                We will pass this along to our product
                                team.:crossed_fingers:
                              </p>
                            </div>
                          </div>
                        ) : (
                          <div>
                            <div className="normal-dark-secendory">
                              <p style={{ textAlign: "left", marginBottom: 8 }}>
                                Your suggestion
                              </p>
                              <TextArea
                                className="width100"
                                maxLength="1000"
                                onChange={(e) =>
                                  this.setFeedback(e.target.value)
                                }
                                value={this.state.feedback}
                                variant="outlined"
                                multiline
                              />
                            </div>
                            <Button
                              type="button"
                              variant="contained"
                              className="btn btn-primary-sm-blue margin-top-40"
                              style={{ marginRight: 16 }}
                              onClick={this.sendFeedback}
                            >
                              Send feedback
                            </Button>
                            <Button
                              type="button"
                              variant="contained"
                              className="btn btn-secondary-sm-blue margin-top-40"
                              onClick={() => this.setState({ openForm: false })}
                            >
                              Cancel
                            </Button>
                          </div>
                        )
                      ) : (
                        <div className="display-flex">
                          <div>
                            <p className="small-dark-secondary">
                              Have any ideas for improving your dashboard?
                            </p>
                            <Button
                              type="button"
                              variant="contained"
                              className="btn btn-primary-sm-blue"
                              style={{ marginTop: 16 }}
                              onClick={this.openForm}
                            >
                              Share an idea
                            </Button>
                          </div>
                          <img
                            src={checkingBoxes}
                            width="80"
                            style={{ transform: "rotateY(180deg)", height: 80 }}
                          ></img>
                        </div>
                      )}
                    </div>
                  </Paper>
                  {(this.state.iscaldepartment ||
                this.state.iscalorganization ||   this.props.AuthenticationAction.login.masterprofileid == 9 ) &&
                  <div>
                    <div
                      className="display-flex margin-bottom-8"
                      style={{ justifyContent: "space-between" }}
                    >
                      {/* <NavLink to="/calendar"> */}
                      <div className="display-flex">
                        <img
                          src={calendarIcon}
                          className="margin-right-8"
                        ></img>
                        <p className="small-dark">sumCAL</p>
                      </div>
                      {/* </NavLink> */}
                      <p className="small-dark-secondary t-bold">
                        {this.state.monthName}
                      </p>
                    </div>
                    <Paper
                      className="padding16 padding-top-8 margin-bottom-16 sumcal-widget"
                      // style={{ height: 300 }}
                      style={{ height: 298 }}
                    >
                      {this.state.calloading ? (
                        <div className="pre-loader" style={{ height: 262 }}>
                          Loading...
                        </div>
                      ) : (
                        <Calendar
                          localizer={localizer}
                          events={this.state.monthviewdata}
                          view={this.state.view}
                          views={["month"]}
                          defaultDate={this.state.defaultDate}
                          date={this.state.defaultDate}
                          step={30}
                          min={this.state.maxDate}
                          max={this.state.minDate}
                          startAccessor="start"
                          endAccessor="end"
                          components={{
                            event: CustomEventContainer({
                              openeventdetails: this.openeventdetails,
                              closeeventdetails: this.closeeventdetails,
                              closedetails: this.closedetails,
                              view: this.state.view,
                              eventdetails: this.state.eventdetails,
                              eventdetails_anchorEl:
                                this.state.eventdetails_anchorEl,

                              selectedDate: this.state.selectedDate,

                              data1: this.state.data1,
                              data2: this.state.data2,
                              showeventdetails: this.showeventdetails,
                              defaultDate: this.state.defaultDate,
                            }),
                          }}
                        />
                      )}
                    </Paper>
                  </div>
  }
                  {this.state.upcomingEvents.length > 0 && (
                    <div className="margin-bottom-24">
                      <LabelIcon
                        label="Upcoming celebrations"
                        img={Celebrate}
                      />
                      <Paper
                        className="padding16 thin-scroll"
                        style={{
                          height: 200,
                          position: "relative",
                          overflowY: "auto",
                          zIndex: 0,
                        }}
                      >
                        {this.state.upcomingEvents.length > 0 ? (
                          this.state.upcomingEvents.map((event) => (
                            <div style={{ padding: "8px 0px" }}>
                              <Grid
                                container
                                style={{ borderBottom: "1px solid #edf5fd" }}
                              >
                                <Grid item xs={12} md={1} sm={12}>
                                  <p className="t-12 margin-top-2">
                                    {event.birthday
                                      ? "🎂"
                                      : event.work
                                      ? "💻"
                                      : "❣️"}
                                  </p>
                                </Grid>
                                <Grid item xs={12} md={5} sm={12}>
                                  <p className="small-dark-secondary">
                                    {event.birthday
                                      ? getFormattedDate(event.dob)
                                      : event.work
                                      ? getFormattedDate(event.doj)
                                      : getFormattedDate(
                                          event.marriageanniversarydate,
                                        )}
                                  </p>
                                </Grid>
                                <Grid item xs={12} md={6} sm={12}>
                                  <p className="small-dark-secondary text-align-right">
                                    {event.fullname}
                                  </p>
                                </Grid>
                              </Grid>
                            </div>
                          ))
                        ) : (
                          <div className="text-align-center margin-top-30">
                            No Records Found
                          </div>
                        )}
                      </Paper>
                    </div>
                  )}
                  {this.state.upcomingHolidays.length > 0 && (
                    <div>
                      <LabelIcon
                        className="floatleft"
                        label="Upcoming holidays"
                        img={holidays}
                      />

                      <span
                        style={{
                          fontSize: 12,
                          verticalAlign: "middle",
                          background: "rgba(1, 7, 9, 0.35)",
                          borderRadius: 4,
                          padding: "0px 4px",
                          marginLeft: 8,
                          color: "#fff",
                          fontWeight: "bold",
                        }}
                      >
                        {this.state.upcomingHolidays.length}
                      </span>
                      <Paper
                        className="thin-scroll clear-float"
                        style={{
                          height: 232,
                          position: "relative",
                          overflowY: "auto",
                        }}
                      >
                        {/* <sectionHeaderExtraSmall
                      header={`${this.state.upcomingHolidays.length} holiday in this month. Yay 🎉`}
                    /> */}
                        {this.state.upcomingHolidays.length > 0 ? (
                          this.state.upcomingHolidays.map((holiday) => (
                            <div style={{ padding: "8px 16px" }}>
                              <Tooltip
                                title={
                                  holiday.ismandatory ? "Mandatory" : "Optional"
                                }
                                placement="top"
                              >
                                <Grid
                                  container
                                  style={{ borderBottom: "1px solid #edf5fd" }}
                                >
                                  {/* <Grid item xs={12} md={1} sm={12}>
                          <p className="t-12 margin-top-2">⛱</p>
                        </Grid> */}
                                  <Grid item xs={12} md={6} sm={12}>
                                    <p className="small-dark-secondary">
                                      {holiday.holidaydate &&
                                        getFormattedDate(holiday.holidaydate)}
                                    </p>
                                  </Grid>
                                  <Grid item xs={12} md={6} sm={12}>
                                    <p className="small-dark-secondary text-align-right">
                                      {holiday.holidayname &&
                                        holiday.holidayname}
                                    </p>
                                  </Grid>
                                </Grid>
                              </Tooltip>
                              {/* <Grid container style={{ position: "absolute", bottom: 8 }}>
                        <p className="width100 margin-top-8 view-more-link">view more</p>
                      </Grid> */}
                            </div>
                          ))
                        ) : (
                          <div className="t-14 text-align-center margin-top-30">
                            No Records Found
                          </div>
                        )}
                      </Paper>
                    </div>
                  )}
                </Grid>

                {/* {this.state.isupdate && <ProductUpdate {...this.state} />} */}
              </Grid>

              <Drawer
                anchor="right"
                open={this.state.isdraweropen}
                onClose={() => this.setState({ isdraweropen: false })}
                classes={{
                  paper: "drawer-main width40 drawer-tabs-scrollable",
                }}
              >
                <div className="padding16">
                  <DrawerHeader
                    header="Who's in right now"
                    closeDrawer={() => this.setState({ isdraweropen: false })}
                  />
                  <div className="">
                    <SearchSq
                      placeholder="Search"
                      value={this.state.searchValue}
                      onChange={this.handleSearch1}
                    />
                  </div>
                  {this.props.AuthenticationAction &&
                    this.props.AuthenticationAction.login &&
                    this.props.AuthenticationAction.login.masterprofileid &&
                    this.props.AuthenticationAction.login.masterprofileid ==
                      9 && (
                      <div className="margin-bottom-16 margin-top-16">
                        <p className="input-label">Office location</p>
                        <Select
                          isMulti
                          className="selectsearch"
                          onChange={(id) =>
                            this.handleChange1("selectedLocationIds", id)
                          }
                          options={this.state.allofficelocationlist}
                          getOptionLabel={(option) => option.displayname}
                          getOptionValue={(option) => option.displayvalue}
                          value={this.state.selectedOfficelocation}
                          placeholder="Select office location"
                          isClearable={false}
                        />
                        <Button
                          variant="contained"
                          className={
                            this.state.selectedLocationIds
                              ? "btn btn-secondary-sm-blue margin-top-8"
                              : "btn btn-secondary-sm-grey margin-top-8"
                          }
                          onClick={() =>
                            this.setState({
                              selectedLocationIds: "",
                              selectedOfficelocation: [],
                              withoutclockin1: this.state.withoutclockin,
                            })
                          }
                          disabled={
                            this.state.selectedLocationIds ? false : true
                          }
                        >
                          Reset
                        </Button>
                      </div>
                    )}
                  <Tabs
                    value={this.state.tabvalue}
                    onChange={this.handleTabChange.bind(this)}
                    indicatorColor="#fff"
                    textColor="primary"
                  >
                    <Tab
                      label="Not clocked-in yet"
                      className={
                        this.state.tabvalue == 0
                          ? "active-tab1"
                          : "inactive-tab1"
                      }
                      style={{ textTransform: "none" }}
                    />
                    {/* <Tab label="LWF benefits" className={`tabheading ${activeTabValue == 1 ? "active-tab1" : "inactive-tab1"} `} /> */}
                    <Tab
                      label="Clocked-out"
                      className={
                        this.state.tabvalue == 1
                          ? "active-tab1"
                          : "inactive-tab1"
                      }
                      style={{ textTransform: "none" }}
                    />
                    <Tab
                      label="Clocked-in"
                      className={
                        this.state.tabvalue == 2
                          ? "active-tab1"
                          : "inactive-tab1"
                      }
                      style={{ textTransform: "none" }}
                    />
                    <Tab
                      label="On leave/ opt holiday"
                      className={
                        this.state.tabvalue == 3
                          ? "active-tab1"
                          : "inactive-tab1"
                      }
                      style={{ textTransform: "none" }}
                    />
                  </Tabs>
                  {this.state.tabvalue == 0 && (
                    <div
                      key="key"
                      className="thin-scroll"
                      style={{
                        height: "calc(100vh - 180px)",
                        overflowY: "auto",
                      }}
                    >
                      {this.state.withoutclockin1.length > 0 ? (
                        <>
                          {this.state.withoutclockin1.map((listdata) => (
                            <div
                              className="display-flex employee-list-drawer"
                              style={{
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <ProfilePicture
                                  src={getFormattedImageLink(
                                    listdata.imagepath,
                                  )}
                                  height="32"
                                />

                                <p className="normal-dark-secondary margin-left-16">
                                  {listdata.employeename || listdata.fullname}
                                </p>
                              </div>
                              {/* <p className="normal-dark-secondary">2:30 pm</p> */}
                            </div>
                          ))}
                        </>
                      ) : this.state.isdrawersearch ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data found.
                        </p>
                      ) : this.state.selectedLocationIds &&
                        this.state.withoutclockin1.length == 0 ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data available
                        </p>
                      ) : (
                        <p className="normal-dark text-align-center margin-top-24">
                          All employees have clocked-in or out for the day.
                        </p>
                      )}
                    </div>
                  )}
                  {this.state.tabvalue == 1 && (
                    <div
                      key="key"
                      className="thin-scroll"
                      style={{
                        height: "calc(100vh - 180px)",
                        overflowY: "auto",
                      }}
                    >
                      {this.state.clockout1.length > 0 ? (
                        <>
                          {this.state.clockout1.map((listdata) => (
                            <div
                              className="display-flex employee-list-drawer"
                              style={{
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <ProfilePicture
                                  src={getFormattedImageLink(
                                    listdata.imagepath,
                                  )}
                                  height="32"
                                />

                                <p className="normal-dark-secondary margin-left-16">
                                  {listdata.employeename || listdata.fullname}
                                </p>
                              </div>
                              <p className="extra-small-dark-secondary margin-top-8">
                                {moment(listdata.outtime, "HH:mm:ss").format(
                                  "hh:mm:ss A",
                                )}
                                {/* {getFormattedTime(listdata.outtime)} */}
                              </p>
                            </div>
                          ))}
                        </>
                      ) : this.state.isdrawersearch ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data found.
                        </p>
                      ) : this.state.selectedLocationIds &&
                        this.state.clockout1.length == 0 ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data available
                        </p>
                      ) : (
                        <p className="normal-dark text-align-center margin-top-24">
                          No employee clocked-out yet.
                        </p>
                      )}
                    </div>
                  )}
                  {this.state.tabvalue == 2 && (
                    <div
                      key="key"
                      className="thin-scroll"
                      style={{
                        height: "calc(100vh - 180px)",
                        overflowY: "auto",
                      }}
                    >
                      {this.state.clockin1.length > 0 ? (
                        <>
                          {this.state.clockin1.map((listdata) => (
                            <div
                              className="display-flex employee-list-drawer"
                              style={{
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <ProfilePicture
                                  src={getFormattedImageLink(
                                    listdata.imagepath,
                                  )}
                                  height="32"
                                />
                                <p className="normal-dark-secondary margin-left-16">
                                  {listdata.employeename || listdata.fullname}
                                </p>
                              </div>
                              <p className="extra-small-dark-secondary">
                                {/* {getFormattedTime(listdata.intime)} */}
                                {moment(listdata.intime, "HH:mm:ss").format(
                                  "hh:mm:ss A",
                                )}
                              </p>
                            </div>
                          ))}
                        </>
                      ) : this.state.isdrawersearch ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data found.
                        </p>
                      ) : this.state.selectedLocationIds &&
                        this.state.clockin1.length == 0 ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data available
                        </p>
                      ) : (
                        <p className="normal-dark text-align-center margin-top-24">
                          No employee clocked-in yet.
                        </p>
                      )}
                    </div>
                  )}
                  {this.state.tabvalue == 3 && (
                    <div
                      key="key"
                      className="thin-scroll"
                      style={{
                        height: "calc(100vh - 180px)",
                        overflowY: "auto",
                      }}
                    >
                      {this.state.onleave1.length > 0 ? (
                        <>
                          {this.state.onleave1.map((listdata) => (
                            <div
                              className="display-flex employee-list-drawer"
                              style={{
                                alignItems: "center",
                                justifyContent: "space-between",
                              }}
                            >
                              <div
                                className="display-flex"
                                style={{ alignItems: "center" }}
                              >
                                <ProfilePicture
                                  src={getFormattedImageLink(
                                    listdata.imagepath,
                                  )}
                                  height="32"
                                />
                                <p className="normal-dark-secondary margin-left-16">
                                  {listdata.employeename || listdata.fullname}
                                </p>
                              </div>
                              <div style={{ textAlign: "right", width: "50%" }}>
                                <p className="normal-dark-secondary ellipsis width100">
                                  {moment(listdata.todate).format(
                                    "YYYY-MM-DD",
                                  ) == moment(new Date()).format("YYYY-MM-DD")
                                    ? "Today"
                                    : getFormattedDaymonth(listdata.todate)}
                                </p>
                                {listdata.holidayname && (
                                  <p className="normal-dark-secondary ellipsis width100">{`Opt holiday: ${listdata.holidayname}`}</p>
                                )}
                              </div>
                            </div>
                          ))}
                        </>
                      ) : this.state.isdrawersearch ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data found.
                        </p>
                      ) : this.state.selectedLocationIds &&
                        this.state.onleave1.length == 0 ? (
                        <p className="normal-dark text-align-center margin-top-24">
                          No data available
                        </p>
                      ) : (
                        <p className="normal-dark text-align-center margin-top-24">
                          No employee on leave.
                        </p>
                      )}
                    </div>
                  )}
                </div>
              </Drawer>
              <Drawer
                anchor="right"
                open={this.state.reactionsDrawer}
                onClose={() =>
                  this.setState({ reactionsDrawer: false, allreactions: [] })
                }
                classes={{
                  paper: "drawer-main width40 drawer-tabs-scrollable",
                }}
              >
                <div className="padding16">
                  <DrawerHeader
                    header="People who reacted"
                    closeDrawer={() =>
                      this.setState({ reactionsDrawer: false })
                    }
                  />
                  <div>
                    {this.state.allreactions &&
                      this.state.allreactions[0] &&
                      this.state.allreactions[0].reactedemployee &&
                      this.state.allreactions[0].reactedemployee.length > 0 &&
                      this.state.allreactions[0].reactedemployee.map((emp) => (
                        <div
                          className="display-flex margin-bottom-16"
                          style={{ alignItems: "center" }}
                        >
                          <img
                            src={
                              emp.imagepath
                                ? this.getFormattedImageLink(emp.imagepath)
                                : defaultEmp
                            }
                            style={{
                              borderRadius: 40,
                              height: 32,
                              width: 32,
                              marginRight: 16,
                            }}
                          ></img>
                          <p className="normal-dark t-bold">{emp.fullname}</p>
                        </div>
                      ))}
                  </div>
                </div>
              </Drawer>

              <Dialog
                fullWidth={true}
                // fullScreen
                maxWidth="sm"
                open={this.state.dialogOpen}
                onClose={this.closedialog}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ height: "100vh" }}
                classes={{
                  scrollPaper: "height80vh",
                  paper: "height80vh",
                }}
              >
                <DialogContent style={{ height: "100%" }}>
                  <Grid container>
                    <Grid item sm={12} md={12}>
                      <div
                        className="display-flex"
                        style={{ justifyContent: "space-between" }}
                      >
                        <div style={{ width: "90%" }}>
                          <p className="large-text-dark-secondary t-bold margin-bottom-4">
                            {this.state.selectedNotice &&
                              this.state.selectedNotice.notice}
                          </p>
                          <p className="extra-small-dark-secondary ellipsis width100">
                            {this.state.selectedNotice &&
                              this.state.selectedNotice.addedbyname}{" "}
                            • &nbsp;
                            {this.state.selectedNotice &&
                              this.state.selectedNotice.noticedate &&
                              moment(
                                this.state.selectedNotice.noticedate,
                              ).format("YYYY-MM-DD")}
                          </p>
                        </div>
                        <div
                          className="display-flex notice-reaction-div"
                          onClick={(e) => {
                            e.stopPropagation();
                            this.openReactionDrawer(
                              this.state.selectedNotice.noticeboardid,
                            );
                          }}
                        >
                          {this.state.selectedNotice &&
                            this.state.selectedNotice.reaction &&
                            this.state.selectedNotice.reaction.length > 0 &&
                            this.state.selectedNotice.reaction[0] &&
                            this.state.selectedNotice.reaction[0].count !=
                              0 && (
                              <p
                                className="large-text-dark-secondary margin-right-4 t-bold cursor-pointer"
                                // style={{ padding: 8 }}
                                // onClick={(e) => {
                                //   e.stopPropagation();
                                //   this.openReactionDrawer(
                                //     this.state.selectedNotice.noticeboardid,
                                //   );
                                // }}
                              >
                                {this.state.selectedNotice &&
                                  this.state.selectedNotice.reaction &&
                                  this.state.selectedNotice.reaction.length >
                                    0 &&
                                  this.state.selectedNotice.reaction[0].count}
                              </p>
                            )}
                          <img
                            src={thumbsupicon}
                            height="24"
                            width="24"
                            // onClick={(e) => {
                            //   e.stopPropagation();
                            //   this.reactToNotice(
                            //     this.state.selectedNotice &&
                            //       this.state.selectedNotice.noticeboardid,
                            //     1,
                            //   );
                            // }}
                            // style={{ padding: 8 }}
                          ></img>
                        </div>
                      </div>
                      {this.state.selectedNotice &&
                        this.state.selectedNotice.attachment &&
                        this.state.selectedNotice.attachment.length > 0 &&
                        this.state.selectedNotice.attachment[0] &&
                        this.state.selectedNotice.attachment[0].filename !=
                          null && (
                          <Grid
                            container
                            style={{ alignItems: "center", marginTop: 16 }}
                          >
                            <div
                              className="avtar-thumb-wrapper-small"
                              style={{
                                height:
                                  this.state.selectedNotice &&
                                  this.state.selectedNotice.attachment &&
                                  this.state.selectedNotice.attachment.length >
                                    0
                                    ? 56
                                    : 24,
                                marginLeft: 0,
                              }}
                            >
                              {this.state.selectedNotice &&
                              this.state.selectedNotice.attachment &&
                              this.state.selectedNotice.attachment.length > 0
                                ? this.state.selectedNotice.attachment.map(
                                    (file, index) =>
                                      index < 4 && (
                                        <Tooltip
                                          key="key"
                                          title={file && file.filename}
                                          placement="top"
                                        >
                                          <div
                                            className={
                                              GetNumberOfEmp(
                                                this.state.selectedNotice
                                                  .attachment.length,
                                              ) > 0
                                                ? "avtar-thumb-blur"
                                                : "avtar-thumb"
                                            }
                                            style={{
                                              height: 56,
                                              width: 56,
                                              marginLeft: 0,
                                              marginRight: 12,
                                              borderRadius: 4,
                                            }}
                                          >
                                            {file && file.filepath && (
                                              <Thumbnail
                                                canDelete={false}
                                                key="i"
                                                doc={{
                                                  url: file && file.filepath,
                                                }}
                                              />
                                            )}
                                          </div>
                                        </Tooltip>
                                      ),
                                  )
                                : ""}
                            </div>
                            {this.state.selectedNotice &&
                            this.state.selectedNotice.attachment &&
                            this.state.selectedNotice.attachment.length > 0 ? (
                              GetNumberOfEmp(
                                this.state.selectedNotice.attachment.length,
                              ) > 0 ? (
                                <div
                                  style={{
                                    fontSize: 14,
                                    color: "#1e8ced",
                                    fontWeight: "bold",
                                    cursor: "pointer",
                                  }}
                                  onClick={() =>
                                    this.setState({
                                      allAttachments: true,
                                      drawerOpen: true,
                                    })
                                  }
                                >
                                  +
                                  {GetNumberOfEmp(
                                    this.state.selectedNotice &&
                                      this.state.selectedNotice.attachment
                                        .length,
                                  )}
                                </div>
                              ) : (
                                ""
                              )
                            ) : (
                              ""
                            )}
                          </Grid>
                        )}
                      <p
                        className="normal-dark-secondary notice-deatils margin-top-8"
                        dangerouslySetInnerHTML={{
                          __html:
                            this.state.selectedNotice &&
                            this.state.selectedNotice.noticedetails,
                        }}
                      >
                        {/* {this.state.selectedNotice &&
                            this.state.selectedNotice.noticedetails} */}
                      </p>

                      {this.state.selectedNotice &&
                        this.state.selectedNotice.addedby &&
                        this.state.selectedNotice.addedby ==
                          this.props.AuthenticationAction.login.userid &&
                        this.state.noticeid == null && (
                          <div className="margin-top-16">
                            <Button
                              variant="contained"
                              className="btn btn-secondary-md-red"
                              onClick={this.deleteNotice}
                              startIcon={<img src={deleteIcon}></img>}
                            >
                              Delete notice
                            </Button>
                          </div>
                        )}
                    </Grid>
                  </Grid>
                </DialogContent>
                {this.state.selectedNotice &&
                  // this.state.selectedNotice.isackrequired &&
                  !this.state.selectedNotice.isempack && (
                    <DialogActions
                      style={{ justifyContent: "center", padding: 16 }}
                    >
                      <div>
                        <Button
                          variant="contained"
                          className="btn btn-primary-md-green"
                          onClick={() =>
                            this.reactToNotice(
                              this.state.selectedNotice.noticeboardid,
                              99,
                            )
                          }
                          endIcon={
                            <img src={thumbsupicon} style={{ height: 16 }} />
                          }
                          style={{ textTransform: "unset" }}
                        >
                          I have read this notice & I acknowledge it
                        </Button>
                      </div>
                    </DialogActions>
                  )}
              </Dialog>

              <Dialog
                fullWidth={true}
                // fullScreen
                maxWidth="sm"
                open={this.state.isnotices}
                // onClose={() => this.setState({ isnotices: false })}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                style={{ height: "100vh" }}
                classes={{
                  scrollPaper: "height80vh",
                  paper: "height80vh",
                }}
              >
                <p
                  className="small-dark"
                  style={{ padding: "24px 0px 0px 24px" }}
                >
                  {this.state.allMandatoryNotices &&
                    this.state.allMandatoryNotices.length}{" "}
                  notice(s) pending to be acknowledged •{" "}
                  {allPendingNotices + 1 - this.state.mandatorycount} of{" "}
                  {/* {this.state.allMandatoryNotices &&
                    this.state.allMandatoryNotices.length} */}
                  {allPendingNotices}
                </p>

                {this.state.allMandatoryNotices &&
                  this.state.allMandatoryNotices.length > 0 &&
                  this.state.allMandatoryNotices.map((x, index) =>
                    index == 0 ? (
                      <div style={{ height: "calc(100% - 143px)" }}>
                        <DialogContent style={{ height: "100%" }}>
                          <Grid container>
                            <Grid item sm={12} md={12}>
                              <div
                                className="display-flex"
                                style={{ justifyContent: "space-between" }}
                              >
                                <div style={{ width: "90%" }}>
                                  <p className="large-text-dark-secondary t-bold margin-bottom-4">
                                    {x && x.notice}
                                  </p>
                                  <p className="extra-small-dark-secondary ellipsis width100">
                                    {x && x.addedbyname} • &nbsp;
                                    {x &&
                                      x.noticedate &&
                                      moment(x.noticedate).format("YYYY-MM-DD")}
                                  </p>
                                </div>
                                <div
                                  className="display-flex notice-reaction-div"
                                  onClick={(e) => {
                                    e.stopPropagation();
                                    this.openReactionDrawer(x.noticeboardid);
                                  }}
                                >
                                  {x &&
                                    x.reaction &&
                                    x.reaction.length > 0 &&
                                    x.reaction[0].count != 0 && (
                                      <p
                                        className="large-text-dark-secondary margin-right-4 t-bold"
                                        // style={{ padding: 8 }}
                                        // onClick={(e) => {
                                        //   e.stopPropagation();
                                        //   this.openReactionDrawer(
                                        //     x.noticeboardid,
                                        //   );
                                        // }}
                                      >
                                        {x.reaction &&
                                          x.reaction.length > 0 &&
                                          x.reaction[0].count}
                                      </p>
                                    )}
                                  <img
                                    src={thumbsupicon}
                                    height="24"
                                    width="24"
                                    // onClick={(e) => {
                                    //   e.stopPropagation();
                                    //   this.reactToNotice(x.noticeboardid, 1);
                                    // }}
                                    // style={{ padding: 8 }}
                                  ></img>
                                </div>
                              </div>
                              {x &&
                                x.attachment &&
                                x.attachment.length > 0 &&
                                x.attachment[0].filename != null && (
                                  <Grid
                                    container
                                    style={{
                                      alignItems: "center",
                                      marginTop: 16,
                                    }}
                                  >
                                    <div
                                      className="avtar-thumb-wrapper-small"
                                      style={{
                                        height:
                                          x &&
                                          x.attachment &&
                                          x.attachment.length > 0
                                            ? 56
                                            : 24,
                                        marginLeft: 0,
                                      }}
                                    >
                                      {x &&
                                      x.attachment &&
                                      x.attachment.length > 0
                                        ? x.attachment.map(
                                            (file, index) =>
                                              index < 4 && (
                                                <Tooltip
                                                  key="key"
                                                  title={file && file.filename}
                                                  placement="top"
                                                >
                                                  <div
                                                    className={
                                                      GetNumberOfEmp(
                                                        x.attachment.length,
                                                      ) > 0
                                                        ? "avtar-thumb-blur"
                                                        : "avtar-thumb"
                                                    }
                                                    style={{
                                                      height: 56,
                                                      width: 56,
                                                      marginLeft: 0,
                                                      marginRight: 12,
                                                      borderRadius: 4,
                                                    }}
                                                  >
                                                    {file && file.filepath && (
                                                      <Thumbnail
                                                        canDelete={false}
                                                        key="i"
                                                        doc={{
                                                          url: file.filepath,
                                                        }}
                                                      />
                                                    )}
                                                  </div>
                                                </Tooltip>
                                              ),
                                          )
                                        : ""}
                                    </div>
                                    {x &&
                                    x.attachment &&
                                    x.attachment.length > 0 ? (
                                      GetNumberOfEmp(x.attachment.length) >
                                      0 ? (
                                        <div
                                          style={{
                                            fontSize: 14,
                                            color: "#1e8ced",
                                            fontWeight: "bold",
                                            cursor: "pointer",
                                          }}
                                          onClick={() =>
                                            this.setState({
                                              allAttachments: true,
                                              drawerOpen: true,
                                            })
                                          }
                                        >
                                          +
                                          {GetNumberOfEmp(
                                            x && x.attachment.length,
                                          )}
                                        </div>
                                      ) : (
                                        ""
                                      )
                                    ) : (
                                      ""
                                    )}
                                  </Grid>
                                )}
                              <p
                                className="normal-dark-secondary notice-deatils margin-top-8"
                                dangerouslySetInnerHTML={{
                                  __html: x && x.noticedetails,
                                }}
                              >
                                {/* {this.state.selectedNotice &&
                        this.state.selectedNotice.noticedetails} */}
                              </p>

                              {/* {x &&
                                x.addedby &&
                                x.addedby ==
                                  this.props.AuthenticationAction.login
                                    .userid && (
                                  <div className="margin-top-16">
                                    <Button
                                      variant="contained"
                                      className="btn btn-secondary-md-red"
                                      onClick={this.deleteNotice}
                                      startIcon={<img src={deleteIcon}></img>}
                                    >
                                      Delete notice
                                    </Button>
                                  </div>
                                )} */}
                            </Grid>
                          </Grid>
                        </DialogContent>
                        {/* {x && x.isackrequired && !x.isempack && ( */}
                        {x && !x.isempack && (
                          <DialogActions
                            style={{ justifyContent: "center", padding: 16 }}
                          >
                            <div>
                              <Button
                                variant="contained"
                                className="btn btn-primary-md-green"
                                onClick={() =>
                                  this.reactToMandatoryNotice(x.noticeboardid)
                                }
                                endIcon={
                                  <img
                                    src={thumbsupicon}
                                    style={{ height: 16 }}
                                  />
                                }
                                style={{ textTransform: "unset" }}
                              >
                                I have read this notice & I acknowledge it
                              </Button>
                            </div>
                          </DialogActions>
                        )}
                      </div>
                    ) : (
                      ""
                    ),
                  )}
              </Dialog>
            </div>
          )}
          {this.state.value == 1 && <AdminSpace />}
        </div>
      </div>
    );
  }
}

home.propTypes = {
  classes: PropTypes.object.isRequired,
  theme: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  refreshProfileInfoReducer: state.refreshProfileInfoReducer,
  SubscriptionData: state.SubscriptionInfo.SubscriptionData,
  AuthenticationAction: state.AuthenticationAction,
  version: state.reactVersion.version,
  SaveInProgressReducer: state.SaveInProgressReducer,
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      reactVersion,
      setSaveProgress,
      removeSaveProgress,
    },
    dispatch,
  );

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(withStyles(styles, { withTheme: true })(withSnackbar(home)));
